<!--
*****************************************************************************
*File : train-information.vue
*Module : Dashboard Frontend
*Purpose : Display the report of the entry & exit  .
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->
<template>
  <v-container
    id="train-information"
    fluid
    tag="section"
  >
  <v-form class="px-3">
  <v-card>
    <base-material-card
          color="success"
          icon="mdi-magnify"
          inline
          class="px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              Select Start Date and Defect Type
              <span class="body-1"></span>
            </div>
          </template>

  <v-layout row gutters>
    <v-flex md3 px-16>
        <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="startdateFormatted"
            transition="scale-transition"
            offset-y
            persistent
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="startdateFormatted"
                label="Select Date"
                hint="DD-MM-YYYY format"
                persistent-hint
                prepend-icon="mdi-calendar-today"
                v-bind="attrs"
                @blur="startdate = parseDate1(startdateFormatted)"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startdate"
              :max = "maxDate"
              scrollable
            >
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="modal = false">Cancel</v-btn>
            <v-btn color="primary" @click="$refs.dialog.save(startdateFormatted)">OK</v-btn>
            </v-date-picker>
        </v-dialog>
  </v-flex>
  <!-- <v-spacer></v-spacer> -->

  <!-- <v-flex md3 px-16>
        <v-dialog
            ref="dialog1"
            v-model="modal1"
            :return-value.sync="enddateFormatted"
            transition="scale-transition"
            offset-y
            persistent
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="enddateFormatted"
                label="Select End Date"
                hint="DD-MM-YYYY format"
                persistent-hint
                prepend-icon="mdi-calendar-today"
                v-bind="attrs"
                @blur="enddate = parseDate1(enddateFormatted)"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="enddate"
              :max = "maxDate"
              scrollable
            >
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="modal1 = false">Cancel</v-btn>
            <v-btn color="primary" @click="$refs.dialog1.save(enddateFormatted)">OK</v-btn>
            </v-date-picker>
        </v-dialog>
  </v-flex> -->

    <!-- <v-flex md3 px-16>
        <v-select
          v-model="dir"
          :items="headers_dir"
          menu-props="auto"
          label="Select Direction"
          hide-details
          prepend-icon="mdi-directions-fork"
          return-object
        ></v-select>
    </v-flex> -->
    

    <v-flex md3 px-16>
        <v-select
          v-model="def_typ"
          :items="headers_defect_type"
          menu-props="auto"
          label="Select Defect Type"
          hide-details
          prepend-icon="mdi-alert-outline"
          return-object
        ></v-select>
    </v-flex>

<!-- <v-spacer></v-spacer> -->
    <!-- <v-flex md3 px-16> -->
        <!-- <v-select -->
          <!-- v-model="alarm_type" -->
          <!-- :items="headers_alerts" -->
          <!-- menu-props="auto" -->
          <!-- label="Select Alert Type" -->
          <!-- hide-details -->
          <!-- prepend-icon="mdi-alert" -->
          <!-- return-object -->
        <!-- ></v-select> -->
    <!-- </v-flex> -->
   <!-- <v-flex md3 px-16>
        <v-select
          v-model="wagon_type"
          :items="wagon_alerts"
          menu-props="auto"
          label="Select Wagon Type"
          hide-details
          prepend-icon="mdi-train"
        ></v-select>
    </v-flex> -->

    <v-flex md4 class="py-4 px-16">
      <v-card-title>
        <div v-if="epochStart <= epochEnd">
      <v-btn v-if="generateBtn" color="success" v-on:click="isHiddenTrainWise= true"
      @click="readDate(parseDate1(startdateFormatted));" :disabled="disabled">GENERATE REPORT</v-btn> 
        </div>
      </v-card-title>
    </v-flex>
  <div v-if="((epochStart > epochEnd))">
    <h3 class="ml-16 red--text font-weight-bold">Kindly choose Start Datetime lesser than the End Datetime.</h3>
  </div>
  </v-layout>

    </base-material-card>
  </v-card>

  <base-material-card
  v-if="isHiddenDaily"
  color="indigo"
  icon="mdi-train"
  inline
  class="px-5 py-3"
  >
  <template v-slot:after-heading>
    <div class="display-1 font-weight-light">
      Consolidated Daywise Report
      </div>
  </template>
    <!-- <v-col
        cols="12"
        sm="6"
        lg="6"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px;"
          />
      </v-col> -->


  <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="6"
      >
         <v-card-title
          class="font-weight-regular display-5 text--primary mt-1 "
        >
           Consolidated Day Wise Report
        </v-card-title>
      </v-col>
        <v-col
        cols="12"
        sm="6"
        lg="6"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px;"
          />
      </v-col>
   </v-row>

  <v-divider class="mt-3" />
  <v-data-table
  :disabled = isFormValidDaily
  :headers="headers_daywise"
  :items="consol"
  :search.sync="search"
  :sort-by="['date']"
  :sort-desc="[true]"
  multi-sort
  fixed-header
  >
  <template v-slot:[`item.date`]="{ item }">
    <!-- <v-text-field v-if="item.date != null" class="font-weight-light text-center" v-text="formatDate1(item.date)" /> -->
    <v-btn outlined
    v-on:click="isHiddenDaily = false;
    isHiddenTrainWise= true;
    readDate(item.date); generateBtn=false;"
    class="title indigo lighten-3"
    >
    {{ formatDate1(item.date) }}</v-btn>
  </template>
  <template v-slot:[`item.total_train_processed`]="{ item }">
    <v-text-field v-if="item.total_train_processed != null" class="font-weight-light text-center" v-text="item.total_train_processed" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <!-- <template v-slot:[`item.train_alerts`]="{ item }">
    <v-text-field v-if="item.train_alerts != null" class="font-weight-light text-center" v-text="item.train_alerts" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template> -->
  <template v-slot:[`item.total_wheels`]="{ item }">
    <v-text-field v-if="item.total_wheels != null" class="font-weight-light text-center" v-text="item.total_wheels" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.total_wagons`]="{ item }">
    <v-text-field v-if="item.total_wagons != null" class="font-weight-light text-center" v-text="(item.total_wagons)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <!-- v-if="this.alarm_type == 'FWILD Maintenance' || this.alarm_type == 'All'" -->
  <template v-slot:[`item.mvis_alerts`]="{ item }" >
    <v-text-field v-if="item.mvis_alerts != null" class="font-weight-light text-center" v-text="(item.mvis_alerts)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.feedback_available`]="{ item }">
    <v-text-field v-if="item.feedback_available != null" class="font-weight-light text-center" v-text="(item.feedback_available)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.true_count`]="{ item }">
    <v-text-field v-if="item.true_count != null" class="font-weight-light text-center" v-text="(item.true_count)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.false_count`]="{ item }">
    <v-text-field v-if="item.false_count != null" class="font-weight-light text-center" v-text="(item.false_count)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.day_true_percentage`]="{ item }">
    <v-text-field v-if="item.mvis_alerts == 0 || item.true_count == 0 || item.true_count == undefined" class="font-weight-light text-center" v-text="0" />
    <v-text-field v-else class="font-weight-light text-center" v-text="(item.day_true_percentage)" />
  </template>
  <template v-slot:[`item.day_false_percentage`]="{ item }">
    <v-text-field v-if="item.mvis_alerts == 0 || item.false_count == 0 || item.false_count == undefined" class="font-weight-light text-center" v-text="0" />
    <v-text-field v-else class="font-weight-light text-center" v-text="(item.day_false_percentage)" />
  </template>

  </v-data-table>
   <v-btn color="indigo" @click="handleDownload">Export as csv/xlsx</v-btn>
  </base-material-card>

  <base-material-card
  v-if="isHiddenTrainWise"
  color="indigo"
  icon="mdi-train"
  inline
  class="px-5 py-3"
  >
  <template v-slot:after-heading >
    <div class="display-1 font-weight-light" absolute>
      Consolidated Trainwise Report on {{formatDate1(dateValue)}}

  <!--  <v-btn absolute right
     color="indigo" @click="isHiddenDaily = true; isHiddenTrainWise = false; generateBtn=true;">
    <v-icon>mdi-arrow-left-bold</v-icon>  Back
    </v-btn>
  -->

    </div>
    </template>

  <v-row>
      <v-col
        cols="24"
        sm="12"
        lg="12">
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          label="Search"
          hide-details
          single-line
          style="max-width: 250px; "
          />
    </v-col>
  </v-row>


  <v-data-table
  :disabled = isFormValidTrainWise
  :headers="headers_train_wise"
  :items="consol_trainwise"
  :search.sync="search"
  :sort-desc="[true]"
  hide-default-footer
  disable-pagination
  >
  <template v-slot:[`item.train_id`]="{item}">
    <v-btn
    outlined
    v-on:click="
    getTrainDetailInfo(item.train_id);
    isHiddenTrainWise = false; isHiddenTrainData = true;"
    :class="getButtonColor(item)">
    {{ item.train_id}}
    </v-btn>
  </template>
  <!-- <template v-slot:[`item.loco_no`]="{ item }">
    <v-text-field v-if="item.loco_no != null" class="font-weight-light text-center" v-text="item.loco_no" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template> -->
  <template v-slot:[`item.dfis_id`]="{ item }">
    <v-text-field v-if="item.dfis_id != null" class="font-weight-light text-center" v-text="item.dfis_id" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.direction`]="{ item }">
    <v-text-field v-if="item.direction != null" class="font-weight-light text-center" v-text="item.direction" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.train_speed`]="{ item }">
    <v-text-field v-if="item.train_speed != null" class="font-weight-light text-center" v-text="(item.train_speed)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.total_axles`]="{ item }">
    <v-text-field v-if="item.total_axles != null" class="font-weight-light text-center" v-text="(item.total_axles)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <!-- <template v-slot:[`item.fwild_maintenance`]="{ item }">
    <v-text-field v-if="item.fwild_maintenance != null" class="font-weight-light text-center" v-text="(item.fwild_maintenance)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.fwild_critical`]="{ item }">
    <v-text-field v-if="item.fwild_critical != null" class="font-weight-light text-center" v-text="(item.fwild_critical)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template> -->
   <template v-slot:[`item.mvis_alerts`]="{ item }">
    <v-text-field v-if="item.mvis_alerts != null" class="font-weight-light text-center" v-text="(item.mvis_alerts)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.train_wise_feedback`]="{ item }">
    <v-text-field v-if="item.train_wise_feedback != null" class="font-weight-light text-center" v-text="(item.train_wise_feedback)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.train_wise_true`]="{ item }">
    <v-text-field v-if="item.train_wise_true != null" class="font-weight-light text-center" v-text="(item.train_wise_true)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.train_wise_false`]="{ item }">
    <v-text-field v-if="item.train_wise_false != null" class="font-weight-light text-center" v-text="(item.train_wise_false)" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
  <template v-slot:[`item.train_wise_true_percentage`]="{ item }">
    <v-text-field v-if="item.mvis_alerts == 0 || item.train_wise_true == 0 || item.mvis_alerts == undefined" class="font-weight-light text-center" v-text="0" />
    <v-text-field v-else class="font-weight-light text-center" v-text="(item.train_wise_true_percentage)" />
  </template>
  <template v-slot:[`item.train_wise_false_percentage`]="{ item }">
    <v-text-field v-if="item.mvis_alerts == 0 || item.train_wise_false == 0 || item.mvis_alerts == undefined" class="font-weight-light text-center" v-text="0" />
    <v-text-field v-else class="font-weight-light text-center" v-text="item.train_wise_false_percentage" />
  </template>

  </v-data-table>

  <v-btn color="indigo" @click="handleTrainWiseDownload">Export as csv/xlsx</v-btn>

</base-material-card>

<!-- All Train Data Table -->

<div v-show = "isHiddenTrainData">
  <br>
  <v-row class="justify-end">
    <v-btn color="indigo"
    @click="isHiddenTrainData=false; isHiddenTrainWise=true; generateBtn = true; clearVars()"
    > <v-icon>mdi-arrow-left-bold</v-icon> Back</v-btn>
  </v-row>
  <v-card >
    <base-material-card
      color="indigo"
      icon="mdi-train"
      size="25"
      inline
      class="px-5 py-3"
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              Train Information
            </div>
          </template>

    <v-layout>
        <v-container fluid>

   <v-data-table
     :headers="header_train_info_1"
     :items="consol_trainconsolidated1"
     :hide-default-footer="true"
     class="elevation-1"
   >

    <template  v-slot:[`item.train_id`]="{ item }">
      <v-text-field v-if="item.train_id != null" class="" v-text="item.train_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.loco_no`]="{ item }">
      <v-text-field v-if="item.loco_no != null" class="" v-text="item.loco_no" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <!-- v-else-if="(item.dfis) == null" -->
    <template  v-slot:[`item.dfis`]="{ item }">
      <!-- <v-text-field v-if="(item.dfis) == null && roleName == 'General'" v-text="item.dfis" />
       <v-text-field v-else-if="item.dfis != null" class="" v-text="item.dfis" /> -->
      <v-dialog        
        hide-overlay
        v-model="dialogDfis"
        max-width="300"
        :retain-focus="false"
        persistent
        class="elevation-0"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            fab
            small
            dark
            v-bind="attrs"
            v-on="on"
            >
            <v-icon @click="rowClickDfis(item)">mdi-pencil</v-icon>
            </v-btn>
            <v-text-field v-if="(item.dfis) == null && roleName == 'General'" v-text="item.dfis" />
       <v-text-field v-else-if="item.dfis != null" class="" v-text="item.dfis" />
        </template>
        <v-card>
            <v-card-title class="text-h5 text--primary">
            DFIS ID
            </v-card-title>
            <v-spacer></v-spacer>

            <v-text-field
            label="Enter DFIS ID"
            outlined
            v-model="dfis"
            >
            </v-text-field>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="dialogDfis = false"
            >
                Cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                @click="addDfisTrainId(item)"
            >
                Save
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </template>

    <template  v-slot:[`item.train_type`]="{ item }">
      <v-text-field v-if="item.train_type != null" class="" v-text="item.train_type" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.axles`]="{ item }">
      <v-text-field v-if="item.axles != null" class="" v-text="item.axles" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>
  </v-data-table>

   <v-data-table
     :headers="header_train_info_2"
     :items="this.consol_trainconsolidated2"
     :hide-default-footer="true"
     disable-items-per-page="true"
     class="elevation-1"
     disable-sort
   >

    <template  v-slot:[`item.ts`]="{ item }">
      <v-text-field v-if="item.ts != null" class="" v-text="item.ts" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.train_speed`]="{ item }">
      <v-text-field v-if="item.train_speed != null" class="" v-text="item.train_speed" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.mvis_alerts`]="{ item }">
      <v-text-field v-if="item.mvis_alerts != null" class="" v-text="item.mvis_alerts" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <!-- <template  v-slot:[`item.maint_wheels`]="{ item }">
      <v-text-field v-if="item.maint_wheels != null" class="" v-text="item.maint_wheels" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.critical_wheels`]="{ item }">
      <v-text-field v-if="item.critical_wheels != null" class="" v-text="item.critical_wheels" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template> -->


   </v-data-table>
    </v-container>
   </v-layout>
    </base-material-card>
  </v-card>
  </div>
  </v-form>
<br>

<div v-if="isHiddenTrainData">
<v-card>
  <base-material-card
    color="indigo"
    icon="mdi-train"
    inline
    class="px-5 py-3"
    v-show = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
             Summary of the Defect Table <span class="body-1"></span>
            </div>
          </template>
    <v-layout>
        <v-container fluid>
   <v-data-table
      :headers="header_mvis_summary"
      :items="items_mvis_summary"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
    <!--  :hide-default-footer="true" -->
    <template v-slot:[`item.defect_type`]="{item}">
      <v-btn outlined class="subtitle-1 font-weight-bold" :class="defectTypeColor(item.defect_type)"
        v-on:click="mvisDefectsSummary(item.defect_type);
        show_mvis_summary=true" 
      >
        {{item.defect_type}}
      </v-btn>
    </template>

    <template v-slot:[`item.mvis_verified_count`]="{item}">
      <v-text-field v-text="item.mvis_verified_count" />
    </template>

    <template v-slot:[`item.mvis_alert_count`]="{item}">
      <v-text-field v-text="item.mvis_alert_count" />
    </template>

    <template v-slot:[`item.feedback_count`]="{item}">
      <v-text-field v-text="item.feedback_count" />
    </template>

    <template v-slot:[`item.feedback_true`]="{item}">
      <v-text-field v-text="item.feedback_true" />
    </template>

    <template v-slot:[`item.feedback_false`]="{item}">
      <v-text-field v-text="item.feedback_false" />
    </template>

    <!-- <template v-slot:[`item.true_percentage`]="{item}">
      <v-text-field v-if="item.mvis_alert_count == 0 || item.feedback_true == 0" v-text="0" />
      <v-text-field v-else v-text="item.true_percentage" />
    </template> -->
    
    <template v-slot:[`item.feedback_missed`]="{item}">
      <v-text-field v-text="item.feedback_missed" />
    </template>
   
    <template v-slot:[`item.false_percentage`]="{item}">
      <v-text-field v-if="item.feedback_false == 0 || item.mvis_alert_count == 0" v-text="0" />
      <v-text-field v-else-if="item.mvis_alert_count > 0" v-text="item.false_percentage" />
    </template>
          
    </v-data-table>
    </v-container>
    </v-layout>
    </base-material-card>

</v-card>

<br v-if="show_mvis_summary">

<!-- MVIS Defects Table from Defects Summary  -->
<v-card
    v-show = show_mvis_summary
  >
    <base-material-card
    color="indigo"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
    v-show = show_mvis_summary
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
             MVIS Defects <span class="body-1"></span>
            </div>

            <v-btn absolute top right color="indigo"
              @click="show_mvis_summary=false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>

    <v-layout>
        <v-container fluid>

    <v-data-table
      :headers="header_defective_wagon_info"
      :items="mvis_summary_arr"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >

    <template  v-slot:[`item.tagged_wagon_id`]="{ item }">
      <v-text-field v-if="item.tagged_wagon_id != null" class="" v-text="item.tagged_wagon_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.tagged_bogie_id`]="{ item }">
      <v-text-field v-if="item.tagged_bogie_id != null" class="" v-text="item.tagged_bogie_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.side`]="{ item }">
      <v-text-field v-if="item.side != null" class="" v-text="item.side" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.defect_image`]="{ item }">
      <PopupImage
        :pathAddress = "(item.defect_image)"
      >
      </PopupImage>
    </template>

    <template  v-slot:[`item.defect_desc`]="{ item }">
      <v-text-field v-if="(item.defect_desc) == null && roleName == 'General'" v-text="item.defect_desc" />
      <v-text-field v-else-if="(item.defect_desc == '-') || (item.defect_desc == null)" class="font-weight-light text-center" v-text="item.defect_desc" />
      <p v-else-if="(item.defect_desc == '003')" class="font-weight-light title" v-text="code3" ></p>
      <p v-else-if="(item.defect_desc == '009')" class="font-weight-light title" v-text="code9" ></p>
      <p v-else-if="(item.defect_desc == '004')" class="font-weight-light title" v-text="code4" ></p>
      <p v-else-if="(item.defect_desc == '006')" class="font-weight-light title" v-text="code6" ></p>
      <p v-else-if="(item.defect_desc == '007')" class="font-weight-light title" v-text="code7" ></p>
      <p v-else-if="(item.defect_desc == '005')" class="font-weight-light title" v-text="code5" ></p>           
      <p v-else-if="(item.defect_desc == '008')" class="font-weight-light title" v-text="code8" ></p>
      <p v-else-if="(item.defect_desc == '001')" class="font-weight-light title" v-text="code1" ></p>
      <p v-else-if="(item.defect_desc == '002')" class="font-weight-light title" v-text="code2" ></p> 
    </template>

    <template  v-slot:[`item.action_taken`]="{ item }"> 
      <!-- <v-text-field v-if="(item.action_taken) === null && roleName == 'General'" v-text="item.action_taken" /> -->

      <!-- v-model="item.action_taken" -->

      <!-- IMP:----- :value = "item.action_taken" -->
      <tr v-if="roleName == 'Supervisor'">
      <v-select attach
      	  :value = "item.action_taken"
          :items="['TRUE DEFECT','FALSE POSITIVE']"
          prepend-icon="mdi-comment-text-multiple-outline"
          label="FEEDBACK"
          v-on:change="updateFeedback(item.defect_image, item.defect_desc, item, $event)"
                    >
                    </v-select>
      </tr>
      <tr v-else>
        <v-text-field v-text="item.action_taken" />
      </tr>
     
    </template>

      <!-- <v-dialog
        v-else-if="(item.action_taken == '-') || (item.action_taken == null)"
        hide-overlay
        v-model="dialogActionWagon"
        max-width="300"
        :retain-focus="false"
        persistent
        class="elevation-0"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            fab
            small
            dark
            v-bind="attrs"
            v-on="on"
            v-if= "roleName === 'A'"
            >
            <v-icon @click="rowClickWagon(item)">mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="text-h5 text--primary">
            Action Taken
            </v-card-title>
            <v-spacer></v-spacer>

            <v-text-field
            label="Enter Action Taken"
            outlined
            v-model="actionTaken_wagon"
            >
            </v-text-field>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="dialogActionWagon = false"
            >
                Cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                @click="addDActionTakenWagon"
            >
                Save
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> -->

    

    <!-- <v-text-field v-else class="font-weight-light text-center" v-text="item.action_taken" /> -->



    <!-- <template  v-slot:[`item.wagon_id`]="{ item }">
      <v-text-field v-if="item.wagon_id != null" class="" v-text="item.wagon_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.wagon_type`]="{ item }">
      <v-text-field v-if="item.wagon_type != null" class="" v-text="item.wagon_type" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template> -->

    </v-data-table>
   
	</v-container>
	</v-layout>
	</base-material-card>
  </v-card>
  
  </div>
<br/>

<!-- <v-card v-if="maint_condn"> -->
  <!-- <v-card
    v-show = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'
  > -->
  <v-card
    v-show = "false"
  >
    <base-material-card
    color="indigo"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
    v-show = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              FWILD Defects <span class="body-1"></span>
            </div>
          </template>

<v-layout>
        <v-container fluid>
    <v-data-table
      :headers="header_defective_wheel_info"
      :items="fwild_defects"
      class="elevation-1"

    >
    <template  v-slot:[`item.axle_id`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.axle_id != null" class="  text-center" v-text="item.axle_id" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.axle_id != null" class="  text-center" v-text="item.axle_id" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.axle_id != null" class=" text-center" v-text="item.axle_id" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.axle_id != null" class=" text-center" v-text="item.axle_id" />
      </v-container>
    </v-container>
    </template>

    <template  v-slot:[`item.axle_timestamp`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.axle_timestamp != null" class="font-weight-medium" v-text="item.axle_timestamp" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.axle_timestamp != null" class="font-weight-medium" v-text="item.axle_timestamp" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.axle_timestamp != null" class="font-weight-medium text-center" v-text="item.axle_timestamp" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.axle_timestamp != null" class="font-weight-medium text-center" v-text="item.axle_timestamp" />
      </v-container>
    </v-container>
    </template>

    <template  v-slot:[`item.side`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
        <v-text-field class="" v-text="item.side" />
    </v-container>
    </template>

    <template  v-slot:[`item.rake_id`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.rake_id != null" class="font-weight-medium" v-text="item.rake_id" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.rake_id != null" class="font-weight-medium" v-text="item.rake_id" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.rake_id != null" class="font-weight-medium text-center" v-text="item.rake_id" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.rake_id != null" class="font-weight-medium text-center" v-text="item.rake_id" />
      </v-container>
    </v-container>
    </template>

    <template  v-slot:[`item.max_dyn_load`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.max_dyn_load != null" class="" v-text="item.max_dyn_load" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.max_dyn_load_right != null" class="" v-text="item.max_dyn_load_right" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.max_dyn_load_left != null" class=" text-center" v-text="item.max_dyn_load_left" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.max_dyn_load_right != null" class=" text-center" v-text="item.max_dyn_load_right" />
      </v-container>
    </v-container>
   </template>

    <template  v-slot:[`item.max_dyn_load_right`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.max_dyn_load_left != null" class="" v-text="item.max_dyn_load_left" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.max_dyn_load_right != null" class="" v-text="item.max_dyn_load_right" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.max_dyn_load_left != null" class=" text-center" v-text="item.max_dyn_load_left" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.max_dyn_load_right != null" class=" text-center" v-text="item.max_dyn_load_right" />
      </v-container>
    </v-container>
   </template>

    <template  v-slot:[`item.ilf`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.ilf != null" class="" v-text="item.ilf" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.ilf_right != null" class="" v-text="item.ilf_right" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.ilf_left != null" class=" text-center" v-text="item.ilf_left" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.ilf_right != null" class=" text-center" v-text="item.ilf_right" />
      </v-container>
    </v-container>
    </template>

    <template  v-slot:[`item.wheel_status`]="{ item }">
      <v-container v-if="item.wheel_status_left >= 2 || item.wheel_status_right >= 2">
      <v-container v-if="item.wheel_status_left == 2">
        <v-text-field v-if="item.wheel_status != null" class="font-weight-medium " v-text="maintWheel" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 2">
        <v-text-field v-if="item.wheel_status_right != null" class="font-weight-medium" v-text="maintWheel" />
      </v-container>
      <v-container v-else-if="item.wheel_status_left == 3">
        <v-text-field v-if="item.wheel_status_left != null" class=" text-center" v-text="criticalWheel" />
      </v-container>
      <v-container v-else-if="item.wheel_status_right == 3">
        <v-text-field v-if="item.wheel_status_right != null" class=" text-center" v-text="criticalWheel" />
      </v-container>
    </v-container>
    </template>

    <template  v-slot:[`item.action_taken`]="{ item }">
      <v-text-field v-if="(item.action_taken) == null && roleName == 'General'" v-text="item.action_taken" />
      <v-dialog
        v-else-if="(item.action_taken) == null"
        hide-overlay
        v-model="dialogActionWheel"
        max-width="300"
        :retain-focus="false"
        persistent
        class="elevation-0"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            fab
            small
            dark
            v-bind="attrs"
            v-on="on"
            >
            <v-icon @click="rowClickWheel(item.action_taken)">mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="text-h5 text--primary">
            Action Taken
            </v-card-title>
            <v-spacer></v-spacer>

            <v-text-field
            label="Enter Action Taken"
            outlined
            v-model="actionTaken_wheel"
            >
            </v-text-field>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="dialogActionWheel = false"
            >
                Cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                @click="addDActionTakenWheel(); dialogActionWheel = false"
            >
                Save
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </template>

    </v-data-table>
  </v-container>
  </v-layout>
  </base-material-card>
  </v-card>
  <!-- <br v-if = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'> -->

<!-- <v-card
    v-show = 'alarm_type.text == "MVIS Alerts" || alarm_type.text == "All"'
  >
    <base-material-card
    color="indigo"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
    v-show = 'alarm_type.text == "MVIS Alerts" || alarm_type.text == "All"'
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
             MVIS Defects <span class="body-1"></span>
            </div>
          </template>

    <v-layout>
        <v-container fluid>

    <v-data-table
      :headers="header_defective_wagon_info"
      :items="mvis_defects"
      class="elevation-1"
    >

    <template  v-slot:[`item.axle_id`]="{ item }">
      <v-text-field v-if="item.axle_id != null" class="" v-text="item.axle_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.axle_timestamp`]="{ item }">
      <v-text-field v-if="item.axle_timestamp != null" class="" v-text="item.axle_timestamp" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.side`]="{ item }">
      <v-text-field v-if="item.side != null" class="" v-text="item.side" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.wagon_id`]="{ item }">
      <v-text-field v-if="item.wagon_id != null" class="" v-text="item.wagon_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.wagon_type`]="{ item }">
      <v-text-field v-if="item.wagon_type != null" class="" v-text="item.wagon_type" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.wagon_position`]="{ item }">
      <v-text-field v-if="item.wagon_position != null" class="" v-text="item.wagon_position" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.defect_image`]="{ item }">
      <PopupImage
        :pathAddress = "(item.defect_image)"
        >
      </PopupImage>
    </template>

    <template  v-slot:[`item.defect_desc`]="{ item }">
      <v-text-field v-if="(item.defect_desc) == null && roleName == 'General'" v-text="item.defect_desc" />
      <v-text-field v-else-if="(item.defect_desc == '-') || (item.defect_desc == null)" class="font-weight-light text-center" v-text="item.defect_desc" />
      <p v-else-if="(item.defect_desc == '001')" class="font-weight-light title" v-text="code1" ></p>
      <p v-else-if="(item.defect_desc == '002')" class="font-weight-light title" v-text="code2" ></p>
      <p v-else-if="(item.defect_desc == '003')" class="font-weight-light title" v-text="code3" ></p>
      <p v-else-if="(item.defect_desc == '004')" class="font-weight-light title" v-text="code4" ></p>
      <p v-else-if="(item.defect_desc == '005')" class="font-weight-light title" v-text="code5" ></p>
      <p v-else-if="(item.defect_desc == '006')" class="font-weight-light title" v-text="code6" ></p>
      <p v-else-if="(item.defect_desc == '007')" class="font-weight-light title" v-text="code7" ></p>
      <p v-else-if="(item.defect_desc == '008')" class="font-weight-light title" v-text="code8" ></p>
      <p v-else-if="(item.defect_desc == '009')" class="font-weight-light title" v-text="code9" ></p>

    </template>

    <template  v-slot:[`item.action_taken`]="{ item }">
      <v-text-field v-if="(item.action_taken) === null && roleName == 'General'" v-text="item.action_taken" />
      <v-dialog
        v-else-if="(item.action_taken == '-') || (item.action_taken == null)"
        hide-overlay
        v-model="dialogActionWagon"
        max-width="300"
        :retain-focus="false"
        persistent
        class="elevation-0"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            fab
            small
            dark
            v-bind="attrs"
            v-on="on"
            >
            <v-icon @click="rowClickWagon(item)">mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="text-h5 text--primary">
            Action Taken
            </v-card-title>
            <v-spacer></v-spacer>

            <v-text-field
            label="Enter Action Taken"
            outlined
            v-model="actionTaken_wagon"
            >
            </v-text-field>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="dialogActionWagon = false"
            >
                Cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                @click="addDActionTakenWagon"
            >
                Save
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-text-field v-else class="font-weight-light text-center" v-text="item.action_taken" />

    </template>
    </v-data-table>
    </v-container>
    </v-layout>
  </base-material-card>
  </v-card> -->
  <v-btn v-show="isHiddenTrainData" color="indigo" @click="handleMVISDownload">Export MVIS Defects as csv/xlsx</v-btn>
<br/>
<!--
  <br v-if = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'>
  <br v-if = 'alarm_type.text == "MVIS Alerts"'/>

  <v-card>
    <base-material-card
    color="indigo"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-1 font-weight-light">
          MVIS Defects Final <span class="body-1"></span>
        </div>
      </template>

      <v-layout>
        <v-container fluid>
          <v-data-table
          :headers="header_mvis_defects"
          :items= "final_mvis_result"
          class="elevation-1"
          >
          </v-data-table>
        </v-container>
      </v-layout>

    </base-material-card>
  </v-card>
-->
<v-card v-show="isHiddenTrainData">
  <base-material-card
  color="indigo"
  icon="mdi-alert"
  inline
  class="px-5 py-3"

  >
     <template v-slot:after-heading>
          <div class="display-1 font-weight-light">
           Wagon Information<span class="body-1"></span>
          </div>
        </template>

  <v-layout>
      <v-container fluid>

  <v-data-table
    :headers="showWagonInfoHeader"
    :items="consol_left_wagon_info"
    class="elevation-1"
  >

  <template  v-slot:[`item.tagged_wagon_id`]="{ item }">
    <v-text-field v-if="item.tagged_wagon_id != null" class="" v-text="item.tagged_wagon_id" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>

  <template  v-slot:[`item.wagon_id`]="{ item }">
      <v-text-field v-if="(item.wagon_id) == null && roleName === 'General'" v-text="item.wagon_id" />
      <v-text-field v-else-if="(item.wagon_id) != null " v-text="item.wagon_id" />
	
    </template>

  <template  v-slot:[`item.wagon_type`]="{ item }">
    <v-text-field v-if="item.wagon_type != null" class="" v-text="item.wagon_type" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>

  <template v-slot:[`item.edit`]="{ item }" v-if = "roleName != 'General'">

       <v-dialog
        v-if="(item.wagon_id) != null ||  (item.wagon_id) == null "
        hide-overlay
        v-model="dialogWagon"
        max-width="300"
        :retain-focus="false"
        persistent
        class="elevation-0"
        >
        <template v-slot:activator="{ on, attrs }">

            <v-btn
            color="primary"
            fab
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            >
            <v-icon size="sm" @click="rowClickWagonId(item)">mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="text-h5 text--primary">
            Wagon Number,{{taggedwagonid}}
            </v-card-title>
            <v-spacer></v-spacer>

            <v-text-field
           
            label="Enter Wagon Number"
            outlined
            value=""
            click:clear
            v-model="wagonno"
            >
            </v-text-field>
          
            <v-text-field
            
            label="Enter Wagon Type"
            outlined 
           
          
            v-model="wagontype"
           >
            </v-text-field>
            

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="dialogWagon = false"
            >
                Cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                @click="addWagonId(item)"
            >
                Save
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </template>
</v-data-table>
</v-container>
</v-layout>
</base-material-card>
</v-card>
<v-btn v-show="isHiddenTrainData" color="indigo" @click="handleWagonDownload">Export as csv/xlsx</v-btn>
<br/>

<br/>
<!--
<v-card
>
  <base-material-card
  color="indigo"
  icon="mdi-alert"
  inline
  class="px-5 py-3"

  >
     <template v-slot:after-heading>
          <div class="display-1 font-weight-light">
           Right Side Wagon Info<span class="body-1"></span>
          </div>
        </template>

  <v-layout>
      <v-container fluid>

  <v-data-table
    :headers="header_right_wagon_info"
    :items="consol_right_wagon_info"
    class="elevation-1"
  >

  <template  v-slot:[`item.tagged_wagon_id`]="{ item }">
    <v-text-field v-if="item.tagged_wagon_id != null" class="" v-text="item.tagged_wagon_id" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>

  <template  v-slot:[`item.wagon_id`]="{ item }">
    <v-text-field v-if="item.wagon_id != null" class="" v-text="item.wagon_id" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>

  <template  v-slot:[`item.wagon_type`]="{ item }">
    <v-text-field v-if="item.wagon_type != null" class="" v-text="item.wagon_type" />
    <v-text-field v-else class="font-weight-light text-center" v-text="0" />
  </template>
</v-data-table>
</v-container>
</v-layout>
</base-material-card>
</v-card>

<br/>
-->

<!-- <v-card
  v-show = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'
  >
-->
<v-card
  v-show = "false"
  >
    <base-material-card
    color="indigo"
    icon="mdi-train"
    inline
    class="px-5 py-3"
    v-show = 'alarm_type.text == "FWILD Maintenance Alerts" || alarm_type.text == "FWILD Critical Alerts" || alarm_type.text == "All"'
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
             Axle Information <span class="body-1"></span>
            </div>
          </template>
    <v-layout>
        <v-container fluid>
   <v-data-table
      :headers="header_all_wheel_info"
      :items="consol_traindetailed"
      class="elevation-1"
    >
   <template  v-slot:[`item.axle_id`]="{ item }">
      <v-text-field v-if="item.axle_id != null" class="" v-text="item.axle_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.rake_id`]="{ item }">
      <v-text-field v-if="item.rake_id != null" class="" v-text="item.rake_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.wagon_type`]="{ item }">
      <v-text-field v-if="item.wagon_type != null" class="" v-text="item.wagon_type" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.wagon_number`]="{ item }">
      <v-text-field v-if="item.wagon_number != null" class="" v-text="item.wagon_number" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

     <template  v-slot:[`item.axle_speed`]="{ item }">
      <v-text-field v-if="item.axle_speed != null" class="" v-text="item.axle_speed" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.avg_dyn_load_left`]="{ item }">
      <v-container v-if="item.wheel_status_left == 1" >
      <v-text-field v-if="item.avg_dyn_load_left != null" class="" v-text="item.avg_dyn_load_left" />
    </v-container>

    <v-container v-else-if="item.wheel_status_left == 2" class="orange lighten-1">
      <v-text-field v-if="item.avg_dyn_load_left != null" class="" v-text="item.avg_dyn_load_left" />
    </v-container>
    <v-container v-else-if="item.wheel_status_left == 3" class="red lighten-1">
          <v-text-field v-if="item.avg_dyn_load_left != null" class="font-weight-light text-center" v-text="item.avg_dyn_load_left" />
      </v-container>
   </template>

   <template  v-slot:[`item.max_dyn_load_left`]="{ item }">
    <v-container v-if="item.wheel_status_left == 1" >
      <v-text-field v-if="item.max_dyn_load_left != null" class="" v-text="item.max_dyn_load_left" />
    </v-container>

    <v-container v-else-if="item.wheel_status_left == 2" class="orange lighten-1">
      <v-text-field v-if="item.max_dyn_load_left != null" class="" v-text="item.max_dyn_load_left" />
    </v-container>
    <v-container v-else-if="item.wheel_status_left == 3" class="red lighten-1">
          <v-text-field v-if="item.max_dyn_load_left != null" class="font-weight-light text-center" v-text="item.max_dyn_load_left" />
      </v-container>
   </template>

    <template  v-slot:[`item.ilf_left`]="{ item }">
      <v-container v-if="item.wheel_status_left == 1" >
      <v-text-field v-if="item.ilf_left != null" class="" v-text="item.ilf_left" />
    </v-container>

    <v-container v-else-if="item.wheel_status_left == 2" class="orange lighten-1">
      <v-text-field v-if="item.ilf_left != null" class="" v-text="item.ilf_left" />
    </v-container>
    <v-container v-else-if="item.wheel_status_left == 3" class="red lighten-1">
          <v-text-field v-if="item.ilf_left != null" class="font-weight-light text-center" v-text="item.ilf_left" />
      </v-container>

    </template>

     <template  v-slot:[`item.wheel_status_left`]="{ item }">

        <v-text-field v-if="item.wheel_status_left == 1" class="font-weight-light text-center" v-text="goodWheel" />
      <v-container v-if="item.wheel_status_left == 2" class="orange lighten-1">
        <v-text-field v-if="item.wheel_status_left == 2" class="font-weight-light text-center" v-text="maintWheel" />
      </v-container>
       <v-container v-if="item.wheel_status_left == 3" class="red lighten-1">
          <v-text-field v-if="item.wheel_status_left == 3" class="font-weight-light text-center" v-text="criticalWheel" />
      </v-container>
    </template>

    <template  v-slot:[`item.defect_image_left`]="{ item }">
      <v-text-field v-if="item.defect_image_left != null" class="" v-text="item.defect_image_left" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

     <template  v-slot:[`item.defect_desc_left`]="{ item }">
      <v-text-field v-if="item.defect_desc_left != null" class="" v-text="item.defect_desc_left" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.avg_dyn_load_right`]="{ item }">
    <v-container v-if="item.wheel_status_right == 1" >
      <v-text-field v-if="item.avg_dyn_load_right != null" class="font-weight-light text-center" v-text="item.avg_dyn_load_right" />
    </v-container>

    <v-container v-else-if="item.wheel_status_right == 2" class="orange lighten-1">
      <v-text-field v-if="item.avg_dyn_load_right != null" class="font-weight-light text-center" v-text="item.avg_dyn_load_right" />
    </v-container>
    <v-container v-else-if="item.wheel_status_right == 3" class="red lighten-1">
          <v-text-field v-if="item.avg_dyn_load_right != null" class="font-weight-light text-center" v-text="item.avg_dyn_load_right" />
      </v-container>
   </template>

   <template  v-slot:[`item.max_dyn_load_right`]="{ item }">
    <v-container v-if="item.wheel_status_right == 1" >
      <v-text-field v-if="item.max_dyn_load_right != null" class="" v-text="item.max_dyn_load_right" />
    </v-container>

    <v-container v-else-if="item.wheel_status_right == 2" class="orange lighten-1">
      <v-text-field v-if="item.max_dyn_load_right != null" class="" v-text="item.max_dyn_load_right" />
    </v-container>
    <v-container v-else-if="item.wheel_status_right == 3" class="red lighten-1">
          <v-text-field v-if="item.max_dyn_load_right != null" class="font-weight-light text-center" v-text="item.max_dyn_load_right" />
      </v-container>
   </template>

    <template  v-slot:[`item.ilf_right`]="{ item }">
      <v-container v-if="item.wheel_status_right == 1" >
      <v-text-field v-if="item.ilf_right != null" class="" v-text="item.ilf_right" />
    </v-container>

    <v-container v-else-if="item.wheel_status_right == 2" class="orange lighten-1">
      <v-text-field v-if="item.ilf_right != null" class="" v-text="item.ilf_right" />
    </v-container>
    <v-container v-else-if="item.wheel_status_right == 3" class="red lighten-1">
          <v-text-field v-if="item.ilf_right != null" class="font-weight-light text-center" v-text="item.ilf_right" />
      </v-container>
    </template>

     <template  v-slot:[`item.wheel_status_right`]="{ item }">
      <v-text-field v-if="item.wheel_status_right == 1" class="font-weight-light text-center" v-text="goodWheel" />
      <v-container v-if="item.wheel_status_right == 2" class="orange lighten-1">
        <v-text-field v-if="item.wheel_status_right == 2" class="font-weight-light text-center" v-text="maintWheel" />
      </v-container>
       <v-container v-if="item.wheel_status_right == 3" class="red lighten-1">
          <v-text-field v-if="item.wheel_status_right == 3" class="font-weight-light text-center" v-text="criticalWheel" />
      </v-container>
    </template>

     <template  v-slot:[`item.defect_image_right`]="{ item }">
      <v-text-field v-if="item.defect_image_right != null" class="" v-text="item.defect_image_right" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template v-slot:[`item.defect_desc_right`]="{ item }">
      <v-text-field v-if="item.defect_desc_right != null" class="" v-text="item.defect_desc_right" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    </v-data-table>
  </v-container>
  </v-layout>
  </base-material-card>
  </v-card>
  <v-btn v-show="false" color="indigo" @click="handleAllWheelDownload">Export as csv/xlsx</v-btn>
<br/>
<br>

    </v-container>
  
    <!-- </v-layout>
  </base-material-card>
  </v-card> -->


  <!-- <v-btn color="indigo" @click="handleDownload">Export as csv/xlsx</v-btn> -->
<!-- </div> -->


  <!-- </v-form>
  </v-container> -->
</template>

<script>
import axios from 'axios';
import Api from '@/views/service/api'
import torpedoesUnloadedVue from './defect-report.vue';
import ApiResponse from '../service/api-response'
import globalConf from '../../../globalConf';
import PopupImage from './popupImage';

export default {
  name: "TrainInformation",
  components: {
    PopupImage,
  },

  data() {
    const currentDate = new Date();
    const currentDateWithOffset = new Date(currentDate.getTime() + (330 * 60 * 1000)); // Adding 330 minutes for UTC+05:30 offset
    const currentDateISOString = currentDateWithOffset.toISOString();
    const startDate1 = currentDateISOString.substr(0, 10);
    const startDateFormatted1 = this.formatDate1(startDate1);

    return {
      
      headersDailyArr: [],
      headersTrainwiseArr: [],
      disabled: false,
      startdate: startDate1,
      startdateFormatted: startDateFormatted1,
        
      enddate: new Date().toISOString().substr(0, 10),
      enddateFormatted: this.formatDate1(new Date().toISOString().substr(0, 10)),
      epochStart: this.epochConvert(new Date().toISOString().substr(0, 10)),
      epochEnd: this.epochConvert(new Date().toISOString().substr(0, 10)),
      maxDate: this.disableFutureDates(new Date()), //"2023-08-24",
      startDate: '',
      endDate:'',
      search: '',
      taggedwagonid:'',
      trainsEE: [],
      trainWise: [],
      trainDetailed: [],
      entered_trains:[],
      entry_exit_total_train: [],
      mvis_result_total_train: [],
      mvis_feedback: [],
      consol: [],
      consol_trainwise: [],
      consol_traindetailed: [],
      consol_trainconsolidated1: [],
      consol_trainconsolidated2: [],
      fwild_defects: [],
      fwild_rightdefects: [],
      mvis_defects: [],
      infoSide: '',
      exit_train: [],
      isFormValid: false,
      modal: false,
      modal1: false,
      isHidden: true,
      downloadLoading: false,
      filename: '',
      autoWidth: true,
      exelArr :[],
      exelArrTrainWise: [],
      bookType: 'xlsx',
      alarm_type: { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      //dir: { text: 'DOWN', show: true, value: 'DOWN', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      dir: { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      def_typ: { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },  
      def_fn_typ: { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" }, 
      selectedFB: null,
      wagon_type: 'All',
      isHiddenDaily: false,
      isHiddenTrainWise: false,
      show_mvis_summary: false,
      isFormValidDaily: true,
      isFormValidTrainWise: true,
      entry_train_wise: [],
      mvis_wise: [],
      train_wise_feedback_result: [],
      entry_train_detailed: [],
      mvis_detailed: [],
      generateBtn: true,
      leftWheelStatus: 0,
      rightWheelStatus: 0,
      actionTaken_wheel: '',
      actionTaken_wagon: '',
      dialogDfis: false,
      dialogWagon: false,
      dialogActionWheel: false,
      dialogActionWagon: false,
      dialogFN: false,
      consol_traindetailed1: [],
      consol_traindetailed2: [],
      consol_traindetailed: [],
      consol_left_wagon_info: [],
      consol_right_wagon_info: [],
      responsedata:[],
      dfis: '',
      wagonno:'',
      wagontype:'',
      FNFeedback: '',
      counter: 0,
      isHiddenTrainData: false,
      items_all_wheel_info: [],
      items_train_info2: [],
      items_train_info1: [],
      day_info: [],
      items: ['All', 'MVIS Alerts', 'FWILD Maintenance', 'FWILD Critical'],
      alerts: ['All', 'MVIS Alerts', 'FWILD Maintenance', 'FWILD Critical'],
      wagon_alerts: ['All'],
      goodWheel: "Good",
      maintWheel: "Maint",
      criticalWheel: "Critical",
      displayHeader: false,
      roleName: this.$store.state.logUserAdmin[0],
      selectedRowWagon: '',
      code1: 'Defective EM Pad',
      code2: 'Open wagon door',
      code3: 'Hanging part (side view)',
      code4: 'Missing spring(s)',
      code5: 'Missing end cap screw(s)',
      code6: 'Broken spring(s)',
      code7: 'Missing axle box cover',
      code8: 'Missing yoke pin support plate bolts',
      code9: 'Hanging part - Undercarriage',

      mvis_defect_code_num: {
        'Hanging part (side view)': '003',
        'Hanging part - Undercarriage': '009',
        'Missing spring(s)': '004',
        'Broken spring(s)': '006',
        'Missing axle box cover': '007',
        'Missing end cap screw(s)': '005',
        'Missing yoke pin support plate bolts': '008',  
        'Defective EM Pad': '001',
        'Open wagon door': '002',              
      },

      mvis_defect_code_desc: {
        '003': 'Hanging part (side view)',
        '009': 'Hanging part - Undercarriage',
        '004': 'Missing spring(s)',
        '006': 'Broken spring(s)',
        '007': 'Missing axle box cover',
        '005': 'Missing end cap screw(s)',               
        '008': 'Missing yoke pin support plate bolts',
        '001': 'Defective EM Pad',
        '002': 'Open wagon door',                        
      },

      mvis_defects_excel: [],
      consol_left_wagon_info_excel: [],
      consol_traindetailed_excel: [],
      items_mvis_summary: [],

      mvis_defect_count_obj: {
        '003' :0,
        '009' :0,
        '004' :0,
        '006' :0,
        '007' :0,
        '005' :0,
        '008' :0,
        '001' :0,
        '002' :0,
      },

      act_tkn: {
        '003' :0,
        '009' :0,
        '004' :0,
        '006' :0,
        '007' :0,
        '005' :0,
        '008' :0,
        '001' :0,
        '002' :0,
      },

      feedback_true: {
        '003' :0,
        '009' :0,
        '004' :0,
        '006' :0,
        '007' :0,
        '005' :0,
        '008' :0,
        '001' :0,
        '002' :0,
      },

      feedback_false: {
        '003' :0,
        '009' :0,
        '004' :0,
        '006' :0,
        '007' :0,
        '005' :0,
        '008' :0,
        '001' :0,
        '002' :0,
      },

      true_percentage: {
        '003' :0,
        '009' :0,
        '004' :0,
        '006' :0,
        '007' :0,
        '005' :0,
        '008' :0,
        '001' :0,
        '002' :0,
      },

      false_percentage: {
        '003' :0,
        '009' :0,
        '004' :0,
        '006' :0,
        '007' :0,
        '005' :0,
        '008' :0,
        '001' :0,
        '002' :0,
      },

      mvis_summary_arr: [],
      mvis_total_summary: [],
      show_mvis_summary: false,
      selected_train_id: '',
      img_name: '',
      new_feedback: '',
      final_mvis_result: [],



      //temp header array for daywise info
      headers_daywise: [
      { text: 'Date', show: true, value: 'date', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Trains', show: true, value: 'total_train_processed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Axles', show: true, value: 'total_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Wagons', show: true, value: 'total_wagons', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'MVIS Alerts', show: true, value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Feedback Given', show: true, value: 'feedback_available', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'True Alerts', show: true, value: 'true_count', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'False Alerts', show: true, value: 'false_count', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Percentage (True Alerts)', show: true, value: 'day_true_percentage', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Percentage (False Alerts)', show: true, value: 'day_false_percentage', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      headers_daily: [
        { text: 'Date', show: true, value: 'date', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Trains', show: true, value: 'total_train_processed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Trains with alerts', show: true, value: 'train_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Axles', show: true, value: 'total_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Wagons', show: true, value: 'total_wagons', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      headers_dir: [
        { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'DOWN', show: true, value: 'DOWN', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'UP', show: true, value: 'UP', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      headers_defect_type: [
        { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Hanging part (side view)', show: true, value: '003', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Hanging part - Undercarriage', show: true, value: '009', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Missing spring(s)', show: true, value: '004', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Broken spring(s)', show: true, value: '006', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Missing axle box cover', show: true, value: '007', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Missing end cap screw(s)', show: true, value: '005', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },                
        { text: 'Missing yoke pin support plate bolts', show: true, value: '008', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defective EM Pad', show: true, value: '001', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Open wagon door', show: true, value: '002', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },        
      ],

      headers_alerts: [
        { text: 'MVIS Alerts', show: true, value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'FWILD Maintenance Alerts', show: false, value: 'fwild_maintenance', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'FWILD Critical Alerts', show: false, value: 'fwild_critical', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      headers_mvis_alerts: [
      { text: 'Date', show: true, value: 'date', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Trains', show: true, value: 'total_train_processed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Axles', show: true, value: 'total_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Wagons', show: true, value: 'total_wagons', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'MVIS Alerts', show: true, value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" }
      ],

      header_left_wagon_info: [
      { text: 'Tagged Wagon ID', value: 'tagged_wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Wagon Number', value: 'wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Wagon Type', value: 'wagon_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      header_right_wagon_info: [
      { text: 'Tagged Wagon ID' , value: 'tagged_wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Wagon Number', value: 'wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Wagon Type', value: 'wagon_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      headers_train_wise: [
        { text: 'Tagged Train ID', value: 'train_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'DFIS ID', value: 'dfis_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Direction', value: 'direction', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Entry Time', value: 'entry_time', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Train Speed ', value: 'train_speed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'MVIS Alerts', show: true, value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Total Axles', value: 'total_axles', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Feedback Given', show: true, value: 'train_wise_feedback', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'True Alerts', show: true, value: 'train_wise_true', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'False Alerts', show: true, value: 'train_wise_false', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Percentage (True Alerts)', show: true, value: 'train_wise_true_percentage', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Percentage (False Alerts)', show: true, value: 'train_wise_false_percentage', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      header_train_info_1: [
        { text: 'Train ID', value: 'train_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Loco Number', value: 'loco_no', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'DFIS ID', value: 'dfis', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Train Type', value: 'train_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Entry Time', value: 'entry_time', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Axle Count', value: 'axles', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      header_train_info_2: [
        { text: 'Last Updated On', value: 'ts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Train Speed', value: 'train_speed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'MVIS Alert', value: 'mvis_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Maint Alert', value: 'maint_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Critical Alert', value: 'critical_wheels', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      header_defective_wheel_info: [
        // { text: 'Axle ID', value: 'axle_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Axle Timestamp', value: 'axle_timestamp', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Side', value: 'side', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Tagged Loco/Wagon ID', value: 'rake_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Max Dynamic Load Left (Ton)', value: 'max_dyn_load_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Max Dynamic Load Right (Ton)', value: 'max_dyn_load_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'ILF Left', value: 'ilf_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'ILF Right', value: 'ilf_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Wheel Status Left', value: 'wheel_status_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Wheel Status Right', value: 'wheel_status_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Action Taken', value: 'action_taken', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      header_defective_wagon_info: [
	{ text: 'Tagged Wagon ID' , value: 'tagged_wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Wagon No.', value: 'tagged_bogie_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Wagon ID', value: 'wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Wagon Type', value: 'wagon_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Side', value: 'side', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defect Image', value: 'defect_image', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defect Description', value: 'defect_desc', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Feedback', value: 'action_taken', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      header_all_wheel_info: [
        { text: 'Axle ID', value: 'axle_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Tagged Loco/ Wagon ID', value: 'rake_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Wagon Type', value: 'wagon_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Wagon Number', value: 'wagon_number', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Axle Speed', value: 'axle_speed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Avg Dynamic Load Left (Ton)', value: 'avg_dyn_load_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Max Dynamic Load Left (Ton)', value: 'max_dyn_load_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'ILF Left', value: 'ilf_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Wheel Status Left', value: 'wheel_status_left', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Avg Dynamic Load Right (Ton)', value: 'avg_dyn_load_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Max Dynamic Load Right (Ton)', value: 'max_dyn_load_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'ILF Right ', value: 'ilf_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Wheel Status Right', value: 'wheel_status_right', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      header_mvis_summary: [
      { text: 'Type of Defect', value: 'defect_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total Units (Verified)', value: 'mvis_verified_count', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Total (Alerts)', value: 'mvis_alert_count', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'Feedback', value: 'feedback_count', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'True Alerts', value: 'feedback_true', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'False Alerts', value: 'feedback_false', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      // { text: 'Missed Alerts', value: 'feedback_missed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      { text: 'False Alerts (%)', value: 'false_percentage', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],

      header_mvis_defects: [
        { text: 'Axle ID', value: 'axle_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Tagged Loco/ Wagon ID', value: 'rake_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Axle Speed', value: 'axle_speed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Tagged Wagon ID', value: 'tagged_wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Wagon Number', value: 'wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Wagon Type', value: 'wagon_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Tagged Bogie ID', value: 'tagged_bogie_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Side', value: 'side', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defect Image', value: 'defect_image', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defect Description', value: 'defect_desc', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Action Taken', value: 'action_taken', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Edit Wagon Number' ,value:'edit', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" }
      ]

    }
  },

  watch: {
    startdate (val) {
      this.startdateFormatted = this.formatDate1(this.startdate)
      this.epochStart = this.epochConvert(this.startdate)
    },
    enddate (val) {
      this.enddateFormatted = this.formatDate1(this.enddate)
      this.epochEnd = this.epochConvert(this.enddate)
    },
    // items_mvis_summary: {
    //         handler:  function(newVal, oldVal) {
    //       console.log("New value: "+ newVal.feedback_count + ", Old value: " + oldVal['feedback_count']);
    //   },
    //     deep: true
    //   }
    // 'items_mvis_summary': function (newVal, oldVal) {
    //   console.log('same', this.items_mvis_summary);
    //       console.log("New value: "+ newVal + ", Old value: " + oldVal);
    //   },
  },

  methods: {
    getButtonColor(item) {
     //console.log('getButtonColorrrr', this.consol_trainwise); Change by DK
      const INDIGO = 'indigo title lighten-3';
      const ORANGE = 'orange title lighten-3';
      const GREEN = 'green title lighten-3';
      const RED = 'red title lighten-3';

      // const dfccil_feedback = item.train_wise_feedback;
      // const mvis_alerts = item.mvis

      console.log('getButtonColor->item', item);

      if (item.mvis_alerts===0 || item.mvis_alerts == undefined ) {
        return INDIGO; // Change color to grey when feedback_count is 0
      } else if (item.mvis_alerts > item.train_wise_feedback && item.train_wise_feedback > 0) {
        return ORANGE; // Change color to orange when mvis_alert_count > feedback_count > 0
      } else if (item.train_wise_feedback === item.mvis_alerts ) {
        return GREEN; // Keep the default color indigo when feedback_count equals mvis_alert_count
      }else if (item.train_wise_feedback === 0 ) {
        return RED; // Keep the default color indigo when feedback_count equals mvis_alert_count
      } else {

        console.log("No match found for getButtonColor") // Default color if none of the conditions are met
	      return 'title';
      }
    },

    clearVars() {
      this.trainDetailed = [];
      this.consol_traindetailed1 = [];
      this.consol_traindetailed2 = [];
      this.consol_traindetailed = [];
      this.entry_train_detailed = [];
      this.fwild_defects = [];
      this.mvis_defect_result = [];
      this.exelArrTrainWise = [];
      this.consol_left_wagon_info = [];
      this.consol_left_wagon_info_excel = [];

      this.mvis_summary_arr = [];
      this.mvis_total_summary = [];
      this.final_mvis_result = [];
      this.items_mvis_summary = [];     
      this.consol_trainwise = [];
      this.mvis_wise = [];
      this.train_wise_feedback = []; 


      // Clear MVIS Defect count obj values
      for ( const i in this.mvis_defect_count_obj ) {
        this.mvis_defect_count_obj[i] = 0;
        this.act_tkn[i] = 0;
        this.feedback_true[i] = 0;
        this.feedback_false[i] = 0;
        this.true_percentage[i] = 0;
        this.false_percentage[i] = 0;
      };

      this.items_mvis_summary = [];

      Api().post('/api/train_wise', {
        train_date: this.dateValue,
        dir: this.dir.value,
        defType: this.def_typ.value,
      })
    .then((response) => {
      console.log("Resultttt",response.data);
      
      this.trainWise = response.data;
      this.entry_train_wise = this.trainWise.final_result;
      this.mvis_wise = this.trainWise.mvis_result;
      this.train_wise_feedback = this.trainWise.train_wise_feedback;
      console.log('train_wise_feedback', this.train_wise_feedback);

      

      for (let i in this.entry_train_wise.result) {
	if(this.mvis_wise.mvis_result[i][2] > 0 || this.def_typ.value === 'All') {	     
          this.consol_trainwise.push({
            'train_id': this.entry_train_wise.result[i][0],
            'dfis_id': this.entry_train_wise.result[i][1],
            'direction': 'DOWN', //this.entry_train_wise.result[i][2],
            //'entry_time': '', //this.entry_train_wise.result[i][3],
            'train_speed': this.entry_train_wise.result[i][2],
            'total_axles': this.entry_train_wise.result[i][3],
            //'fwild_maintenance': this.entry_train_wise.result[i][7],
            //'fwild_critical': this.entry_train_wise.result[i][8],
            'mvis_alerts': this.mvis_wise.mvis_result[i][2],
            'train_wise_feedback': this.train_wise_feedback.train_wise_feedback_result[i][1],
            'train_wise_true': this.train_wise_feedback.train_wise_feedback_result[i][2],
            'train_wise_false': this.train_wise_feedback.train_wise_feedback_result[i][3],
            'train_wise_true_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][2] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
            'train_wise_false_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][3] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
          })	
               
	}
      }
  //     console.log('consol___trainwise', this.consol_trainwise) 
  // for (let i in this.train_wise_feedback.train_wise_feedback_result) {
  //         this.consol_trainwise.push({
  //           'train_id': this.entry_train_wise.result[i][0],
  //           'dfis_id': this.entry_train_wise.result[i][1],
  //           'direction': 'DOWN', //this.entry_train_wise.result[i][2],
  //           //'entry_time': '', //this.entry_train_wise.result[i][3],
  //           'train_speed': this.entry_train_wise.result[i][5],
  //           'total_axles': this.entry_train_wise.result[i][6],
  //           // 'fwild_maintenance': this.entry_train_wise.result[i][7],
  //           // 'fwild_critical': this.entry_train_wise.result[i][8],
  //           'mvis_alerts': this.mvis_wise.mvis_result[i][2], 
  //           'train_wise_feedback': this.train_wise_feedback.train_wise_feedback_result[i][1],
  //           'train_wise_true': this.train_wise_feedback.train_wise_feedback_result[i][2],
  //           'train_wise_false': this.train_wise_feedback.train_wise_feedback_result[i][3],
  //           'train_wise_true_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][2] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
  //           'train_wise_false_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][3] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
            
         
  //         } )

  //     }
      console.log('consol_trainwiseeeee', this.consol_trainwise);
    })

    
      
    this.consol = [];

    //update consolidated day wise report
    Api().post('/api/train_information', {
        start: this.startDate,
        end: this.startDate,
        alarmtype: this.alarm_type,
        train_type: this.wagon_type,
        dir: this.dir.value,
        defType: this.def_typ.value,
      })
    .then((response) => {
      // console.log(response.data);
      this.trainsEE = response.data;
      this.entry_exit_total_train = this.trainsEE.final_result;
      this.mvis_result_total_train = this.trainsEE.mvis_result;
      this.mvis_feedback = this.trainsEE.mvis_feedback;
      console.log('total_axles', this.mvis_feedback, this.entry_exit_total_train.result);

      if (this.alarm_type.text === 'All') {
        for (let i in this.entry_exit_total_train.result) {
            this.consol.push({
              'date': this.entry_exit_total_train.result[i][0], //timestamp value
              'total_train_processed': this.mvis_result_total_train.mvis_result[i][2],
              // 'total_train_unprocessed': this.entry_exit_total_train.result[i][2],
              // 'train_alerts': this.entry_exit_total_train.result[i][3],
              'total_wheels': (this.entry_exit_total_train.result[i][2]),
	            //'total_wagons': Math.round((this.entry_exit_total_train.result[i][3] - (this.entry_exit_total_train.result[i][1]*6))/4),
	            'total_wagons': Math.round((this.entry_exit_total_train.result[i][2])/4),
              'mvis_alerts': this.mvis_result_total_train.mvis_result[i][1],
              'feedback_available': this.mvis_feedback.mvis_feedback_count[i][1],
              'true_count': this.mvis_feedback.mvis_feedback_count[i][2],
              'false_count': this.mvis_feedback.mvis_feedback_count[i][3],
              // 'fwild_maintenance': this.entry_exit_total_train.result[i][5],
              // 'fwild_critical': this.entry_exit_total_train.result[i][6],
              'day_true_percentage': parseFloat((this.mvis_feedback.mvis_feedback_count[i][2] * 100) / this.mvis_result_total_train.mvis_result[i][1]).toFixed(2),
              'day_false_percentage': parseFloat((this.mvis_feedback.mvis_feedback_count[i][3] * 100) / this.mvis_result_total_train.mvis_result[i][1]).toFixed(2),
            })
        }
       }

      console.log('this.consol', this.consol);

    })
    .catch(function (error) {
      //  console.log(error);
      ApiResponse.checkErrorCode(error.response.status);
    });
     

    },

    getMaintCriticalCounts() {
      let maint_left = this.fwild_defects[0].wheel_status_left
      let maint_right = this.fwild_defects[0].wheel_status_right
      console.log(this.fwild_defects[0].wheel_status_left);
      // if (maint_left || maint_right >= 2) {
      //   this.maint_condn = 1;
      // }
      // else {
      //   this.maint_condn = 0;
      // }
      // console.log(this.maint_condn);
    },

    addDfisTrainId(row) {
      console.log(this.dfis);
      this.selectedRow = row;
      Api().post('api/dfisdata', {
        trainId: this.selectedRow.train_id,
        dfisId: this.dfis
        })
        .then((response) => {
            console.log("Saved to DB!");
            // console.log(response.data);
            //   autoupdate in the page once the number is updated
            let len=this.consol_trainconsolidated1.length;
            for(let i=0;i<len;i++){
              if(this.selectedRow.train_id==this.consol_trainconsolidated1[i]['train_id']){
                this.consol_trainconsolidated1[i]['dfis']=this.dfis;
              }
            };

            Api().post('api/dfisdata', {
              })
              .then((response) => {
                   console.log(response.data);
                // this.dashboardFullDay = response.data;

                    const splitKeyValue = obj => {
                        const keys = Object.keys(obj);
                        const res = [];
                        for(let i = 0; i < keys.length; i++){
                            res.push({
                                'train_id': obj[keys[i]]["train_id"],
                                'dfis_train_id': obj[keys[i]]["dfis_train_id"]
                            });
                        };
                        return res;
                        };

                    // this.day_info = splitKeyValue(this.dashboardFullDay);

                })
                .catch(function (error) {
                    // console.log(error);
                    ApiResponse.checkErrorCode(error.response.status);
                });
                this.dialogDfis = false;
                // this.snackbar = true;
        })
        .catch(function (error) {
            ApiResponse.checkErrorCode(error.response.status);
        });
    },
    addWagonId(row) {
      console.log(this.wagonno);
      console.log(this.wagontype);
      if (this.wagonid!=''){
      Api().post('api/wagondata', {
        taggedWagonId: this.selectedRow.tagged_wagon_id,
        trainId: this.consol_trainconsolidated1[0]['train_id'],
        wagonId: this.wagonno,
        wagonType:this.wagontype
        })
        .then((response) => {
            console.log(" the wagon data is Saved to DB!");
            console.log(response.data);
            let len=this.consol_left_wagon_info.length;
            console.log(len);
            for(let i=0;i<len;i++){
              if (this.selectedRow.tagged_wagon_id==this.consol_left_wagon_info[i]['tagged_wagon_id']) {
                this.consol_left_wagon_info[i]['wagon_id']=this.wagonno;
              }
            };
            //
                this.dialogWagon = false;
                this.wagonno='';
                // this.snackbar = true;
        })
        .catch(function (error) {
            ApiResponse.checkErrorCode(error.response.status);
        });
      }


      if (this.wagontype!=''){
      Api().post('api/wagondata', {
        taggedWagonId: this.selectedRow.tagged_wagon_id,
        trainId: this.consol_trainconsolidated1[0]['train_id'],
        wagonId: this.wagonid,
        wagonType:this.wagontype
        })
        .then((response) => {
            console.log(" the wagon data is Saved to DB!");
            console.log(response.data);
            let len=this.consol_left_wagon_info.length;
            console.log(len);
            for(let i=0;i<len;i++){
              if (this.selectedRow.tagged_wagon_id==this.consol_left_wagon_info[i]['tagged_wagon_id']) {
                this.consol_left_wagon_info[i]['wagon_type']=this.wagontype;
              }
            };
            //
                this.dialogWagon = false;
                this.wagontype='';
                // this.snackbar = true;
        })
        .catch(function (error) {
            ApiResponse.checkErrorCode(error.response.status);
        });
      }

    },

    addDActionTakenWheel() {
      console.log(this.actionTaken_wheel);
    },

    addDActionTakenWagon() {
      console.log(this.actionTaken_wagon, this.consol_trainconsolidated1[0]['train_id']);
      Api().post('api/defectaction', {
        trainId: this.consol_trainconsolidated1[0]['train_id'],
        taggedWagonId: this.selectedRowWagon.tagged_wagon_id,
        taggedBogieId: this.selectedRowWagon.tagged_bogie_id,
        action_taken: this.actionTaken_wagon
        })
        .then((response) => {
            console.log("Saved to DB!");
             console.log("JYOO",response.data);
            //   autoupdate in the page once the number is updated
            let len=this.mvis_defects.length;
            for(let i=0;i<len;i++)
            {
              if (this.selectedRowWagon.tagged_wagon_id==this.mvis_defects[i]['tagged_wagon_id'] && this.selectedRowWagon.tagged_bogie_id ==this.mvis_defects[i]['tagged_bogie_id'])
              {
                this.mvis_defects[i]['action_taken']=this.actionTaken_wagon;
              }
            };
          Api().post('api/defectaction', {
            })
            .then((response) => {
                 console.log(response.data);
                 const splitKeyValue = obj => {
                  const keys = Object.keys(obj);
                  const res = [];
                  for(let i = 0; i < keys.length; i++){
                      res.push({
                          'train_id': obj[keys[i]]["train_id"],
                          'action_taken': obj[keys[i]]["action_taken"]
                      });
                  };
                  return res;
                  };
            })
              .catch(function (error) {
                  // console.log(error);
                  ApiResponse.checkErrorCode(error.response.status);
              });
              this.actionTaken_wagon = false;
              this.dialogActionWagon = false;
                // this.snackbar = true;
        })
        .catch(function (error) {
            ApiResponse.checkErrorCode(error.response.status);
        });
    },

    rowClickDfis(row) {
          this.selectedRow = row;
          console.log(this.selectedRow);
        //   clear the phone_num before updating to the next
          this.dfis = '';
      },
      rowClickWagonId(row) {
          this.selectedRow = row;
          this.taggedwagonid=this.selectedRow.tagged_wagon_id;
          console.log(this.selectedRow);
          //this.wagonno =this.selectedRow.wagon_id;
          //this.wagontype=this.selectedRow.wagon_type;

        //   clear the phone_num before updating to the next
          this.wagon_id ='';
          this.wagon_type='';
	  this.wagonid ='';
          this.wagontype='';
        },

        submitFeedback(row) {
          this.selectedFB = row;
          console.log("fb", row);
        },

        changedLabel(label) {
          //receive the label of the value selected (the label shown in the select, or an empty string)
          console.log("cg-label", label);
        },

      rowClickWheel(row) {
          this.selectedRow = row;
          console.log(this.selectedRow);
        //   clear the phone_num before updating to the next
          this.actionTaken_wheel = '';
      },

      rowClickWagon(row) {
          this.selectedRowWagon = row;
          console.log(this.selectedRowWagon);
        //   clear the phone_num before updating to the next
          this.actionTaken_wagon = '';
      },

    convertTime(dateWithT) {
      var d = new Date(dateWithT);

      return (d.toString().slice(0, 24));

    },

    getSide(leftWheel, rightWheel) {
      if (leftWheel >= 2) {
        this.infoSide = "Left"
      }
      else if (rightWheel >=2) {
        this.infoSide = "Right"
      }
      return (this.infoSide);
    },

    getTrainDetailInfo(trainId) {

      this.selected_train_id = trainId
      this.generateBtn = false;
      this.trainDetailed = [];
      this.consol_trainconsolidated1 = [];
      this.consol_trainconsolidated2 = [];
      this.consol_traindetailed = [];
      this.entry_train_detailed = [];
      this.mvis_detailed = [];
      this.fwild_defects = [];
      this.mvis_defects = [];
      this.exelArr = [];
      this.exelArrTrainWise = [];
      this.responsedata = [];

      Api().post('/api/train_detailed', {
        train_date: this.dateValue,
        trainId: trainId,
        defType: this.def_typ.value,
      })
    .then((response) => {

      this.trainDetailed = response.data;
      this.entry_train_detailed = this.trainDetailed.final_result;
      this.responsedata= this.trainDetailed;
      // console.log("Response data", this.responsedata);
      console.log("Train Final Result", this.entry_train_detailed);

      //****************REQUIRED FOR MERGE TABLES (final_mvis_result) *************/



      // Find the max length of data parameters

      /*
	var maxLen = Math.max(this.entry_train_detailed.detail_result.length,
      this.entry_train_detailed.mvis_defect_result.length,
      this.entry_train_detailed.mvis_left_wagon_result.length,
      )
      console.log("Max Len", maxLen);
      var minLen = Math.min(this.entry_train_detailed.detail_result.length,
      this.entry_train_detailed.mvis_defect_result.length,
      this.entry_train_detailed.mvis_left_wagon_result.length,
      )
      console.log("Min Len", minLen);
	*/

      // try {
      //   let decide = this.entry_train_detailed.detail_result[0][0];
      //   console.log("From Try", decide);
      // } catch(e) {
      //   console.log("From Decide", this.entry_train_detailed.detail_result[1][0]);
      // }


      // console.log("Tertiary Operator ", this.entry_train_detailed.detail_result[300][0]
      // === undefined ? '-' : this.entry_train_detailed.detail_result[1][0]);

	/*
      for (let i = 0; i < maxLen; ++i) {
        try {

          this.final_mvis_result.push({

          'axle_id': this.entry_train_detailed.detail_result[i][0],
          'rake_id': this.entry_train_detailed.detail_result[i][1],
          'axle_speed': this.entry_train_detailed.detail_result[i][2],
          'tagged_wagon_id': this.entry_train_detailed.mvis_defect_result[i][1],
          'wagon_id': this.entry_train_detailed.mvis_left_wagon_result[i][2],
          'wagon_type': this.entry_train_detailed.mvis_left_wagon_result[i][3],
          'tagged_bogie_id': this.entry_train_detailed.mvis_defect_result[i][2],
          'side': this.entry_train_detailed.mvis_defect_result[i][3],
          'defect_image': globalConf.djangoBackend + '/media/images/' + this.entry_train_detailed.mvis_defect_result[i][6],
          'defect_desc': this.entry_train_detailed.mvis_defect_result[i][7],
          'action_taken': this.entry_train_detailed.mvis_defect_result[i][8],
          'edit': ''
        })
        } catch(e) {
          let j = minLen -1
          console.log("From Catch j val ",j);
          j += 1;
          if( j < maxLen ) {
            j++;
            try {
            this.final_mvis_result.push({

              'axle_id': this.entry_train_detailed.detail_result[j][0],
              'rake_id': this.entry_train_detailed.detail_result[j][1],
              'axle_speed': this.entry_train_detailed.detail_result[j][2],
              'tagged_wagon_id': this.entry_train_detailed.mvis_defect_result[j][1],
              'wagon_id': this.entry_train_detailed.mvis_left_wagon_result[j][2],
              'wagon_type': this.entry_train_detailed.mvis_left_wagon_result[j][3],
              'tagged_bogie_id': this.entry_train_detailed.mvis_defect_result[j][2],
              'side': this.entry_train_detailed.mvis_defect_result[j][3],
              'defect_image': globalConf.djangoBackend + '/media/images/' + this.entry_train_detailed.mvis_defect_result[j][6],
              'defect_desc': this.entry_train_detailed.mvis_defect_result[j][7],
              'action_taken': this.entry_train_detailed.mvis_defect_result[j][8],
              'edit': ''
              })


            } catch(e) {
              this.final_mvis_result.push({

                'axle_id': '-',
                'rake_id': '-',
                'axle_speed': '-',
                'tagged_wagon_id': '-',
                'wagon_id': '-',
                'wagon_type': '-',
                'tagged_bogie_id': '-',
                'side': '-',
                'defect_image': '-',
                'defect_desc': '-',
                'action_taken': '-',
                'edit': '-',
                })
            }

        }
        j++;
      }
    }

      console.log("Final Mvis Array\n", this.final_mvis_result)
	*/

      for (let i in this.entry_train_detailed.consolidated_result) {
        this.consol_trainconsolidated1.push({
          'train_id': this.entry_train_detailed.consolidated_result[i][0],
          'loco_no': this.entry_train_detailed.mvis_defect_result[i][9],
          'dfis': this.entry_train_detailed.consolidated_result[i][1],
          //'entry_time': '', //this.entry_train_detailed.consolidated_result[i][3],
          'axles': this.entry_train_detailed.consolidated_result[i][3],
        })
      }

      //left side wagon entry

      for (let i in this.entry_train_detailed.mvis_left_wagon_result) {
        this.consol_left_wagon_info.push({
          'tagged_wagon_id': this.entry_train_detailed.mvis_left_wagon_result[i][0],
          'wagon_id': this.entry_train_detailed.mvis_left_wagon_result[i][2],
          'wagon_type': this.entry_train_detailed.mvis_left_wagon_result[i][3],
          'edit':"",
        });

        this.consol_left_wagon_info_excel.push({
          'tagged_wagon_id': this.entry_train_detailed.mvis_left_wagon_result[i][0],
          'wagon_id': this.entry_train_detailed.mvis_left_wagon_result[i][2],
          'wagon_type': this.entry_train_detailed.mvis_left_wagon_result[i][3],
        })
      }

      //right side wagon entry

      for (let i in this.entry_train_detailed.mvis_right_wagon_result) {
        this.consol_right_wagon_info.push({
          'tagged_wagon_id': this.entry_train_detailed.mvis_right_wagon_result[i][0],
          'wagon_id': this.entry_train_detailed.mvis_right_wagon_result[i][2],
          'wagon_type': this.entry_train_detailed.mvis_right_wagon_result[i][3],
        })
      }


      for (let i in this.entry_train_detailed.consolidated_result) {
          this.consol_trainconsolidated2.push({
           // 'direction': this.entry_train_detailed.consolidated_result[i][2],
           'train_speed': this.entry_train_detailed.consolidated_result[i][2],
	          'ts': this.entry_train_detailed.mvis_defect_result[i][0],            
          })
      }
      console.log('check dfis', this.consol_trainconsolidated2, this.entry_train_detailed.mvis_defect_result);


	/*	
      for (let i in this.entry_train_detailed.detail_result) {
        this.consol_traindetailed.push({
          'axle_id': this.entry_train_detailed.detail_result[i][0],
          'rake_id': this.entry_train_detailed.detail_result[i][1],
          'axle_speed': this.entry_train_detailed.detail_result[i][2],
          'avg_dyn_load_left': this.entry_train_detailed.detail_result[i][3],
          'max_dyn_load_left': this.entry_train_detailed.detail_result[i][4],
          'ilf_left': this.entry_train_detailed.detail_result[i][5],
          'wheel_status_left': this.entry_train_detailed.detail_result[i][6],
          'avg_dyn_load_right': this.entry_train_detailed.detail_result[i][7],
          'max_dyn_load_right': this.entry_train_detailed.detail_result[i][8],
          'ilf_right': this.entry_train_detailed.detail_result[i][9],
          'wheel_status_right': this.entry_train_detailed.detail_result[i][10],
        });

        this.consol_traindetailed_excel.push({
          'axle_id': this.entry_train_detailed.detail_result[i][0],
          'rake_id': this.entry_train_detailed.detail_result[i][1],
          'axle_speed': this.entry_train_detailed.detail_result[i][2]
        })
      }
	*/
      // console.log(this.consol_traindetailed);

      for (let i in this.entry_train_detailed.defect_result) {
        // this.leftWheelStatus = this.entry_train_detailed.defect_result[i][8]
        // this.rightWheelStatus = this.entry_train_detailed.defect_result[i][9]
        // console.log('i=>left=>right', i, this.leftWheelStatus, this.rightWheelStatus);
      // }


      // if(this.leftWheelStatus >= 2 ) {
        // for (let i in this.entry_train_detailed.defect_result) {
          this.fwild_defects.push({
            'axle_id': this.entry_train_detailed.defect_result[i][0],
            'axle_timestamp': this.entry_train_detailed.defect_result[i][1],
            'rake_id': this.entry_train_detailed.defect_result[i][2],
            'axle_speed': this.entry_train_detailed.defect_result[i][3],
            'max_dyn_load_left': this.entry_train_detailed.defect_result[i][4],
            'max_dyn_load_right': this.entry_train_detailed.defect_result[i][5],
            'ilf_left': this.entry_train_detailed.defect_result[i][6],
            'ilf_right': this.entry_train_detailed.defect_result[i][7],
            'wheel_status_left': this.entry_train_detailed.defect_result[i][8],
            'wheel_status_right': this.entry_train_detailed.defect_result[i][9],
            'side': this.getSide(this.entry_train_detailed.defect_result[i][8], this.entry_train_detailed.defect_result[i][9]),
          })
        }
      // }

      // else if(this.rightWheelStatus >= 2 ) {
      //   // for (let i in this.entry_train_detailed.defect_result) {
      //     this.fwild_rightdefects.push({
      //       'axle_id': this.entry_train_detailed.defect_result[i][0],
      //       'axle_timestamp': this.entry_train_detailed.defect_result[i][1],
      //       'rake_id': this.entry_train_detailed.defect_result[i][2],
      //       'axle_speed': this.entry_train_detailed.defect_result[i][3],
      //       'max_dyn_load': this.entry_train_detailed.defect_result[i][5],
      //       'ilf': this.entry_train_detailed.defect_result[i][7],
      //       'wheel_status': this.entry_train_detailed.defect_result[i][9],
      //       'side': this.getSide(this.entry_train_detailed.defect_result[i][8], this.entry_train_detailed.defect_result[i][9]),
      //     })
      //   }
      // }

    // console.log('fwild_defects', this.fwild_leftdefects, this.fwild_rightdefects);

      // MVIS Defects
      let aux_mvis_defects = [];
      for (let i in this.entry_train_detailed.mvis_defect_result) {
        aux_mvis_defects.push({
            'tagged_wagon_id': this.entry_train_detailed.mvis_defect_result[i][1],
            'tagged_bogie_id': this.entry_train_detailed.mvis_defect_result[i][2],
            'side': this.entry_train_detailed.mvis_defect_result[i][3],
            'wagon_id': this.entry_train_detailed.mvis_defect_result[i][4],
            'wagon_type': this.entry_train_detailed.mvis_defect_result[i][5],
            'defect_image': globalConf.djangoBackend + '/media/images/' + this.entry_train_detailed.mvis_defect_result[i][6],
            'defect_desc': this.entry_train_detailed.mvis_defect_result[i][7],
            'action_taken': this.entry_train_detailed.mvis_defect_result[i][8]
          });
          console.log('mvis_defects', this.entry_train_detailed.mvis_defect_result,aux_mvis_defects);
        this.mvis_defects_excel.push({
            'tagged_wagon_id': this.entry_train_detailed.mvis_defect_result[i][1],
            'tagged_bogie_id': this.entry_train_detailed.mvis_defect_result[i][2],
            'side': this.entry_train_detailed.mvis_defect_result[i][3],
            'wagon_id': this.entry_train_detailed.mvis_defect_result[i][4],
          // 'wagon_type': this.entry_train_detailed.mvis_defect_result[i][5],
          //  'defect_image': globalConf.djangoBackend + '/media/images/' + this.entry_train_detailed.mvis_defect_result[i][6],
            'defect_desc': this.entry_train_detailed.mvis_defect_result[i][7],
            'action_taken': this.entry_train_detailed.mvis_defect_result[i][8]
        })
      }
	let resultUniqueObj = this.getUniqueObjects(aux_mvis_defects);
        for (let i in resultUniqueObj) {
          let def_img_full_path = resultUniqueObj[i]['defect_image'].split('/')
          let final_img_name = def_img_full_path[def_img_full_path.length - 1];
        this.mvis_defects.push({
            'tagged_wagon_id': resultUniqueObj[i]['tagged_wagon_id'],
            'tagged_bogie_id': resultUniqueObj[i]['tagged_bogie_id'], //WAGON NUMBER ADDED
            'side': resultUniqueObj[i]['side'],
            'defect_image': globalConf.djangoBackend + '/media/images/' + final_img_name,
            'defect_desc': resultUniqueObj[i]['defect_desc'],
            'action_taken': resultUniqueObj[i]['action_taken'],
            'feedback_rd': resultUniqueObj[i]['feedback_rd'],
            'decision': resultUniqueObj[i]['decision'], 
        });
        }

      console.log('mvis_defects', resultUniqueObj);

      //Extract defect_desc code from mvis_defects arr

      for (let i = 0 ; i < this.mvis_defects.length; ++i ) {

        for ( const j in this.mvis_defect_count_obj ) {
          if ( this.mvis_defects[i].defect_desc === j ) {
            this.mvis_defect_count_obj[j] += 1;
          }
          if(this.mvis_defects[i].defect_desc === j && this.mvis_defects[i].action_taken != '-') {              
            this.act_tkn[j] += 1;          
          }
          if(this.mvis_defects[i].defect_desc === j && this.mvis_defects[i].action_taken === 'TRUE DEFECT') {              
            this.feedback_true[j] += 1;  
            this.true_percentage[j] = parseFloat((this.feedback_true[j] * 100) / this.mvis_defect_count_obj[j].mvis_alert_count).toFixed(2); 
            this.false_percentage[j] = parseFloat((this.feedback_false[j] * 100) / this.mvis_defect_count_obj[j].mvis_alert_count).toFixed(2);       
          }
          if(this.mvis_defects[i].defect_desc === j && this.mvis_defects[i].action_taken === 'FALSE POSITIVE') {              
            this.feedback_false[j] += 1; 
            this.true_percentage[j] = parseFloat((this.feedback_true[j] * 100) / this.mvis_defect_count_obj[j].mvis_alert_count).toFixed(2);
            this.false_percentage[j] = parseFloat((this.feedback_false[j] * 100) / this.mvis_defect_count_obj[j].mvis_alert_count).toFixed(2);         
          }
        }

       }

       console.log("Defect Objjjj", this.mvis_defects);

       
	//this.items_mvis_summary.push(
        //{
        //  'defect_type': 'Defective EM Pad',
        //  'mvis_alert_count': this.mvis_defect_count_obj['001']
        //},
        //{
        //  'defect_type': 'Open wagon door',
        //  'mvis_alert_count': this.mvis_defect_count_obj['002']
        //},
        //{
        //  'defect_type': 'Hanging part (side view)',
        //  'mvis_alert_count': this.mvis_defect_count_obj['003']
        //},
        //{
        //  'defect_type': 'Missing spring(s)',
        //  'mvis_alert_count': this.mvis_defect_count_obj['004']
        //},
        //{
        //  'defect_type': 'Missing end cap screw(s)',
        //  'mvis_alert_count': this.mvis_defect_count_obj['005']
        //},
        //{
        //  'defect_type': 'Broken spring(s)',
        //  'mvis_alert_count': this.mvis_defect_count_obj['006']
        //},
        //{
        //  'defect_type': 'Missing axle box cover',
        //  'mvis_alert_count': this.mvis_defect_count_obj['007']
        //},
        //{
        //  'defect_type': 'Missing yoke pin support plate (Undercarriage)',
        //  'mvis_alert_count': this.mvis_defect_count_obj['008']
        //},
        //{
        //  'defect_type': 'Hanging part (Undercarriage)',
        //  'mvis_alert_count': this.mvis_defect_count_obj['009']
        //},

        for (const j in this.mvis_defect_count_obj) {
            if (this.def_typ.value == "All") {
              if (this.mvis_defect_code_desc[j] == "Defective EM Pad" && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 8),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? (parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 8 - this.feedback_true[j] - 0)
                  ).toFixed(2)) : 0),
                  
                });
              } else if (this.mvis_defect_code_desc[j] == "Hanging part (side view)" && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if (
                (this.mvis_defect_code_desc[j] == "Missing spring(s)" ||
                this.mvis_defect_code_desc[j] == "Broken spring(s)") && this.mvis_defect_count_obj[j] > 0
              ) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 4),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 4 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if (this.mvis_defect_code_desc[j] == "Missing axle box cover" && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 8),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 8 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if (this.mvis_defect_code_desc[j] == "Missing yoke pin support plate bolts" && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 2),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 2 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if (this.mvis_defect_code_desc[j] == 'Open wagon door' && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 4),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 4 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if (this.mvis_defect_code_desc[j] == 'Hanging part - Undercarriage' && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if (this.mvis_defect_code_desc[j] == 'Missing end cap screw(s)' && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 8),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  // true_percentage: parseFloat(
                  //   (this.feedback_true[j] * 100) / (this.feedback_true[j] + 0)
                  // ).toFixed(2),
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 8 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              }
            } else {
              if(this.def_typ.value == '003' && (
                this.mvis_defect_code_desc[j] == "Hanging part (side view)" && this.mvis_defect_count_obj[j] > 0)) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });              
              } else if (this.def_typ.value == '009' && (
                this.mvis_defect_code_desc[j] == 'Hanging part - Undercarriage' && this.mvis_defect_count_obj[j] > 0)) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if((this.def_typ.value == '004' || this.def_typ.value == '006') && (
                (this.mvis_defect_code_desc[j] == "Missing spring(s)" ||
                this.mvis_defect_code_desc[j] == "Broken spring(s)") && this.mvis_defect_count_obj[j] > 0
              )) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 4),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 4 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if((this.def_typ.value == '007' || this.def_typ.value == '005' ) && (
                (this.mvis_defect_code_desc[j] == "Missing axle box cover" || this.mvis_defect_code_desc[j] == 'Missing end cap screw(s)') 
                && this.mvis_defect_count_obj[j] > 0)) {
                  this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 8),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 8 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if(this.def_typ.value == '008' && this.mvis_defect_code_desc[j] == "Missing yoke pin support plate bolts" && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 2),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 2 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else if(this.def_typ.value == '001' && this.mvis_defect_code_desc[j] == "Defective EM Pad" && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 8),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? (parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 8 - this.feedback_true[j] - 0)
                  ).toFixed(2)) : 0)
                });
              } else if(this.def_typ.value == '002' && this.mvis_defect_code_desc[j] == 'Open wagon door' && this.mvis_defect_count_obj[j] > 0) {
                this.items_mvis_summary.push({
                  defect_type: this.mvis_defect_code_desc[j],
                  mvis_verified_count: (this.consol_left_wagon_info.length * 4),
                  mvis_alert_count: this.mvis_defect_count_obj[j],
                  feedback_count: this.act_tkn[j],
                  feedback_true: this.feedback_true[j],
                  feedback_false: this.feedback_false[j],
                  feedback_missed: 0,
                  false_percentage: (this.consol_left_wagon_info.length > 0 ? parseFloat(
                    (this.feedback_false[j] * 100) /
                      (this.consol_left_wagon_info.length * 4 - this.feedback_true[j] - 0)
                  ).toFixed(2) : 0)
                });
              } else {
                console.log('Pls check on defect type !');
              }
            }
            
      console.log('new', this.items_mvis_summary);
    }

       //)


      // this.$router.push({ name: 'Train Detail Report', params: { train_id: trainId, train_info1: this.consol_trainconsolidated1, train_info2: this.consol_trainconsolidated2,
      // all_wheel_info:  this.consol_traindetailed, fwild_defects: this.fwild_defects, mvis_defects: this.mvis_defects } })
    //})
    //.catch(function (error) {
      //  console.log(error);
    //  ApiResponse.checkErrorCode(error.response.status);
    });
    },

    defectTypeColor(defType) {
      if(defType === 'Hanging part (side view)') {
        return 'red lighten-2'
      } else if(defType === 'Missing spring(s)') {
        return 'blue lighten-3'
      } else if(defType === 'Broken spring(s)') {
        return 'lime lighten-2'
      } else if(defType === 'Hanging part - Undercarriage') {
        return 'green lighten-3'
      } else if(defType === 'Defective EM Pad') {
        return 'amber lighten-2'
      } else if(defType === 'Open wagon door') {
        return 'brown lighten-3'
      } else if(defType === 'Missing end cap screw(s)') {
        return 'cyan lighten-3'
      } else if(defType === 'Missing axle box cover') {
        return 'blue-grey lighten-2'
      } else if(defType === 'Missing yoke pin support plate bolts') {
        return 'teal lighten-4'
      } else {
        return ''
      }

    },

    // getUniqueObjects(arr) {
    //     const uniqueObjs = new Map();
    //     console.log('getUniqueObjects arr: ', arr);
    //     for (const dataDict of arr) {
    //       console.log('dataDict', dataDict)
    //       const key = `${dataDict.tagged_wagon_id}${dataDict.side}${dataDict.defect_desc}${dataDict.action_taken}`;
    //       if (!uniqueObjs.has(key)) {
    //         uniqueObjs.set(key, dataDict);
    //       }
    //     }
    //     // console.log('getUniqueObjects', Array.from(uniqueObjs.values()));
    //     return Array.from(uniqueObjs.values());
    //       //     const trainArr = [];

    //       // for (let trainTup of trainVal) {
    //       //     let wagNo, side, defId, actionTaken = trainTup;
    //       //     let containsDuplicate = false;

    //       //     if (actionTaken === '-') {
    //       //         for (const innerTup of trainVal) {
    //       //             let inWagNo, inSide, inDefId, inActionTaken = innerTup;

    //       //             if (inWagNo === wagNo && inSide === side && inDefId === defId && inActionTaken !== actionTaken) {
    //       //                 containsDuplicate = true;
    //       //                 break;
    //       //             }
    //       //         }
    //       //     }

    //       //     if (!containsDuplicate) {
    //       //         trainArr.push(trainTup);
    //       //     }
    //       // }

    //       // return trainArr;
    //     },

//     getUniqueObjects(arr) {
//     const recordsMap = new Map(); // To track records by key and action_taken
//     const dashOnlyKeys = new Set(); // To track keys with only '-' entries

//     // First pass: categorize records by key and action_taken
//     for (const dataDict of arr) {
//         const { tagged_wagon_id, side, defect_desc, action_taken } = dataDict;
//         const key = `${tagged_wagon_id}${side}${defect_desc}`;

//         if (!recordsMap.has(key)) {
//             recordsMap.set(key, {
//                 'TRUE DEFECT': null,
//                 'FALSE POSITIVE': null,
//                 '-': null
//             });
//         }

//         const keyMap = recordsMap.get(key);
//         if (action_taken === '-' || action_taken === 'TRUE DEFECT' || action_taken === 'FALSE POSITIVE') {
//             keyMap[action_taken] = dataDict; // Store one of each action_taken
//         }

//         // Track keys that only have '-' entries
//         if (action_taken === '-') {
//             dashOnlyKeys.add(key);
//         } else {
//             dashOnlyKeys.delete(key);
//         }
//         console.log("unique",recordsMap);
//     }
    
//     // Collect the results
//     const result = [];

//     for (const keyMap of recordsMap.values()) {
//         if (keyMap['TRUE DEFECT']) {
//             result.push(keyMap['TRUE DEFECT']);
//         }
//         if (keyMap['FALSE POSITIVE']) {
//             result.push(keyMap['FALSE POSITIVE']);
//         }
//         // Include '-' only if it's not overshadowed by other types
//         if (!keyMap['TRUE DEFECT'] && !keyMap['FALSE POSITIVE'] && keyMap['-']) {
//             result.push(keyMap['-']);
//         }
        
//     }
//     console.log("Get unique data",result);

//     return result;
// },
getUniqueObjects(arr) {
    const recordsMap = new Map(); // To track records by key and action_taken
    const dashOnlyKeys = new Set(); // To track keys with only '-' entries

    // First pass: categorize records by key and action_taken
    for (const dataDict of arr) {
        const { tagged_wagon_id, side, defect_desc, action_taken } = dataDict;
        const key = `${tagged_wagon_id}${side}${defect_desc}`;

        if (!recordsMap.has(key)) {
            recordsMap.set(key, {
                'TRUE DEFECT': null,
                'FALSE POSITIVE': null,
                '-': null
            });
        }

        const keyMap = recordsMap.get(key);
        if (action_taken === '-' || action_taken === 'TRUE DEFECT' || action_taken === 'FALSE POSITIVE') {
            keyMap[action_taken] = dataDict; // Store one of each action_taken
        }

        // Track keys that only have '-' entries
        if (action_taken === '-') {
            dashOnlyKeys.add(key);
        } else {
            dashOnlyKeys.delete(key);
        }
    }

    // Collect the results
    const result = [];

    for (const keyMap of recordsMap.values()) {
        if (keyMap['TRUE DEFECT']) {
            result.push(keyMap['TRUE DEFECT']);
            // Remove FALSE POSITIVE if TRUE DEFECT exists
            keyMap['FALSE POSITIVE'] = null;
        }
        if (keyMap['FALSE POSITIVE']) {
            result.push(keyMap['FALSE POSITIVE']);
        }
        // Include '-' only if it's not overshadowed by other types
        if (!keyMap['TRUE DEFECT'] && !keyMap['FALSE POSITIVE'] && keyMap['-']) {
            result.push(keyMap['-']);
        }
    }
    console.log("Get unique data", result);

    return result;
},

    mvisDefectsSummary(codeName) {
      this.mvis_summary_arr = [];
      Api().post('/api/mvis_defect_summary', {
        trainId: this.selected_train_id,
        mvis_defect_code: this.mvis_defect_code_num[`${codeName}`]
      })
      .then(response => {
        let mvis_summary_table_result = [];
	let aux_summary = [];
        let summary_res = response.data.final_result;
        mvis_summary_table_result = summary_res.mvis_defect_summary_result;
        for ( let i in mvis_summary_table_result ) {
          // this.mvis_summary_arr[i].action_taken = '-';

          aux_summary.push({
	          'tagged_wagon_id': mvis_summary_table_result[i][1],
            'tagged_bogie_id': mvis_summary_table_result[i][2], //WAGON NUMBER ADDED
            //'tagged_bogie_id': this.entry_train_detailed.mvis_left_wagon_result[i][2], 
            'side': mvis_summary_table_result[i][3],
            'defect_image': globalConf.djangoBackend + '/media/images/' + mvis_summary_table_result[i][4],
            'defect_desc': mvis_summary_table_result[i][5],
            'action_taken': mvis_summary_table_result[i][6],
            //'wagon_id': mvis_summary_table_result[i][7],
            //'wagon_type': mvis_summary_table_result[i][8],
          })
        }
	let resultUniqueObj = this.getUniqueObjects(aux_summary);
        for (let i in resultUniqueObj) {
          let def_img_full_path = resultUniqueObj[i]['defect_image'].split('/')
          let final_img_name = def_img_full_path[def_img_full_path.length - 1];
        this.mvis_summary_arr.push({
            'tagged_wagon_id': resultUniqueObj[i]['tagged_wagon_id'],
            'tagged_bogie_id': resultUniqueObj[i]['tagged_bogie_id'], //WAGON NUMBER ADDED
            'side': resultUniqueObj[i]['side'],
            'defect_image': globalConf.djangoBackend + '/media/images/' + final_img_name,
            'defect_desc': resultUniqueObj[i]['defect_desc'],
            'action_taken': resultUniqueObj[i]['action_taken'],
            'feedback_rd': resultUniqueObj[i]['feedback_rd'],
            'decision': resultUniqueObj[i]['decision'], 
        });
        }
        console.log('After: ', resultUniqueObj);
      })
      
      },

      updateFeedback(def_img, def_code, itm, event) {
        console.log('Old', itm.action_taken);  // Old value
        console.log('act_tkn', event);

        this.new_feedback = event;
        this.img_name = def_img.split('/')[5];
        

        let fbIndex = this.items_mvis_summary.findIndex((obj => obj.defect_type == this.mvis_defect_code_desc[def_code]));
        console.log('fbIndex', fbIndex);

        // let imgIndex = this.mvis_summary_arr.findIndex((obj => obj.defect_desc == def_code));
        // console.log('imgIndex', imgIndex, 'index0', this.mvis_summary_arr[0].action_taken, 'index1',this.mvis_summary_arr[1][0], 'full',this.mvis_summary_arr);


        if(itm.action_taken === '-') {
          console.log('Old', itm.action_taken);          
          this.items_mvis_summary[fbIndex].feedback_count += 1;
         
          if(event == 'TRUE DEFECT') {
            itm.action_taken = 'TRUE DEFECT';
            this.items_mvis_summary[fbIndex].feedback_true += 1;
            this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
            this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);

          } else if (event == 'FALSE POSITIVE') {
            itm.action_taken = 'FALSE POSITIVE';
            this.items_mvis_summary[fbIndex].feedback_false += 1;
            this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
            this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
            
          }

        } else if (itm.action_taken == 'TRUE DEFECT') { //prev value is true
          // false positive will be incremented and true count will be decremented
          itm.action_taken = 'FALSE POSITIVE';
          if(this.items_mvis_summary[fbIndex].feedback_true < 0) {
            this.items_mvis_summary[fbIndex].feedback_true = 0;
          } else {
            this.items_mvis_summary[fbIndex].feedback_true -= 1;
          }
          console.log('chk - changed to FALSE? ', itm.action_taken);
          this.items_mvis_summary[fbIndex].feedback_false += 1;
          this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          
        } else if (itm.action_taken == 'FALSE POSITIVE') { //prev value is false
          // true positive will be incremented and false count will be decremented
          itm.action_taken = 'TRUE DEFECT';
          this.items_mvis_summary[fbIndex].feedback_true += 1;
          if(this.items_mvis_summary[fbIndex].feedback_false < 0) {
            this.items_mvis_summary[fbIndex].feedback_false = 0;
          } else {
            this.items_mvis_summary[fbIndex].feedback_false -= 1;
          }
          this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          
        }
 
        else {
        //Nothing
        }
          

        console.log("count obj", this.feedback_true, this.act_tkn, this.feedback_false);

        let img_name = def_img.split('/')[5];
        Api().post('api/mvis_update_feedback', {
            trainId: this.selected_train_id,
            def_img: img_name,
            act_tkn: event
              })
              .then((response) => {
                   console.log(response.data);
                   
                  })
                .catch(function (error) {
                    // console.log(error);
                    ApiResponse.checkErrorCode(error.response.status);
                });
      },

    readDate(date) {
      //console.log(month);
      this.disabled = false;
      this.dateValue = date;
      console.log("TS DATE", date);
      Api().post('/api/train_wise', {
        train_date: this.dateValue,
        dir: this.dir.value,
        defType: this.def_typ.value,
      })
    .then((response) => {
      console.log('Result /api/train_wiseeee', response.data);
      this.consol_trainwise = [];
      this.trainWise = response.data;
      this.entry_train_wise = this.trainWise.final_result;
      this.mvis_wise = this.trainWise.mvis_result;
      console.log("this.mvis_wise: ", this.mvis_wise)
      this.train_wise_feedback = this.trainWise.train_wise_feedback;
      console.log("Train wise ",this.entry_train_wise)

      for (let i in this.entry_train_wise.result) {
	if(this.mvis_wise.mvis_result[i][2] > 0 || this.def_typ.value === 'All') {
          this.consol_trainwise.push({
            'train_id': this.entry_train_wise.result[i][0],
            'dfis_id': this.entry_train_wise.result[i][1],
            'direction': 'DOWN', //this.entry_train_wise.result[i][2],
            //'entry_time': '', //this.entry_train_wise.result[i][3],
            'train_speed': this.entry_train_wise.result[i][2],
            'total_axles': this.entry_train_wise.result[i][3],
            // 'fwild_maintenance': this.entry_train_wise.result[i][7],
            // 'fwild_critical': this.entry_train_wise.result[i][8],
            'mvis_alerts': this.mvis_wise.mvis_result[i][2], 
            'train_wise_feedback': this.train_wise_feedback.train_wise_feedback_result[i][1],
            'train_wise_true': this.train_wise_feedback.train_wise_feedback_result[i][2],
            'train_wise_false': this.train_wise_feedback.train_wise_feedback_result[i][3],
            'train_wise_true_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][2] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
            'train_wise_false_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][3] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2), 
         
       } )   
        
         


	}}
 

      //   for (let i in this.train_wise_feedback.train_wise_feedback_result) {
      //     this.consol_trainwise.push({
      //       'train_id': this.entry_train_wise.result[i][0],
      //       'dfis_id': this.entry_train_wise.result[i][1],
      //       'direction': 'DOWN', //this.entry_train_wise.result[i][2],
      //       //'entry_time': '', //this.entry_train_wise.result[i][3],
      //       'train_speed': this.entry_train_wise.result[i][5],
      //       'total_axles': this.entry_train_wise.result[i][6],
      //       // 'fwild_maintenance': this.entry_train_wise.result[i][7],
      //       // 'fwild_critical': this.entry_train_wise.result[i][8],
      //       'mvis_alerts': this.mvis_wise.mvis_result[i][2], 
      //       'train_wise_feedback': this.train_wise_feedback.train_wise_feedback_result[i][1],
      //       'train_wise_true': this.train_wise_feedback.train_wise_feedback_result[i][2],
      //       'train_wise_false': this.train_wise_feedback.train_wise_feedback_result[i][3],
      //       'train_wise_true_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][2] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
      //       'train_wise_false_percentage': parseFloat((this.train_wise_feedback.train_wise_feedback_result[i][3] * 100) / this.mvis_wise.mvis_result[i][2]).toFixed(2),
            
         
      //     } )
      // }
    
      console.log("Train wise Feedback",this.train_wise_feedback);
     


      for (let i in this.entry_train_wise.result) {
        let train_id = this.entry_train_wise.result[i][0]
        let dfis_id = this.entry_train_wise.result[i][1]
        let direction = this.entry_train_wise.result[i][2]
        //let entry_time = this.entry_train_wise.result[i][3]
        let train_speed = this.entry_train_wise.result[i][5]
        let total_axles = this.entry_train_wise.result[i][6]
        let fwild_maintenance = this.entry_train_wise.result[i][7]
        let fwild_critical = this.entry_train_wise.result[i][8]
        let mvis_alerts = this.mvis_wise.mvis_result[i][2]

      let data = {
          'TaggedTrainID': train_id,
          'DFISID': dfis_id,
          'Direction': direction,
          //'EntryTime': entry_time,
          'TrainSpeed': train_speed,
          'TotalAxles': total_axles,
          // 'FWILDMaintenanceAlerts': fwild_maintenance,
          // 'FWILDCriticalAlerts': fwild_critical,
          'MVISAlerts' : mvis_alerts
        }
      this.exelArrTrainWise.push(data);
      }
    })
    .catch(function (error) {
      //  console.log(error);
      ApiResponse.checkErrorCode(error.response.status);
    });
    },

    formatDate1 (date) {
      this.disabled = false;
      let datenoTime = new Date(date);
      let monthVal = 0;
      let dateVal = 0;      
      if(datenoTime.getDate() <= 9) {
        dateVal = "0" + datenoTime.getDate();
      } else {
        dateVal = parseInt(datenoTime.getDate());
      }

      if(datenoTime.getMonth() <= 9) {
        monthVal = "0" + (datenoTime.getMonth() + 1);
      } else {
        monthVal = parseInt(datenoTime.getMonth() + 1);
      }
      let dateRecvd = datenoTime.getFullYear() + "-" + monthVal + "-" + dateVal;      
      if (!date) return null
      // console.log("date", date);     

      const [year, month, day] = date.split('-')
      return (`${day}-${month}-${year}`)
    },
    epochConvert (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      // console.log((new Date(year, month - 1, day)).getTime())
      return ((new Date(year, month - 1, day)).getTime())
    },
//    parseDate1 (date) {
//      if (!date) return null

//     const [year, month, day] = date.split('-')
      // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
//     return (`${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`)
//   },

	parseDate1 (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
	console.log('date', year, month, day);
      return (`${day}-${month}-${year}`)
    },

    disableFutureDates(datenoTime) {
      let monthVal = 0;
      let dateVal = 0;      
      if(datenoTime.getDate() < 9) {
        dateVal = "0" + datenoTime.getDate();
      } else {
        dateVal = parseInt(datenoTime.getDate());
      }

      if(datenoTime.getMonth() < 9) {
        monthVal = "0" + (datenoTime.getMonth() + 1);
      } else {
        monthVal = parseInt(datenoTime.getMonth() + 1);
      }
      let dateRecvd = datenoTime.getFullYear() + "-" + monthVal + "-" + dateVal; 
      return dateRecvd
    },

    getSectionStatus (section_status) {
      if (section_status == 'occupied') return 'mdi-minus-circle-outline'
      else if (section_status == 'cleared') return 'mdi-checkbox-marked-circle-outline'
      else return 'mdi-block-helper'
    },
    putSScolor (section_status) {
      let color = (section_status === 'occupied' ) ? 'red' : 'green';
    	return color;
    },
    getTrainDirection (direction) {
      // if (direction == 'in') return 'mdi-arrow-left-bold-circle-outline'
      // else if (direction == 'out') return 'mdi-arrow-right-bold-circle-outline'
      if (direction == 'in') return 'mdi-arrow-bottom-left-thick'
      else if (direction == 'out') return 'mdi-arrow-top-right-thick'
      else return 'mdi-block-helper'
    },
    handleDownload() {

      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Date', 'Total Trains', 'Total Wheels', 'MVIS Alerts']
        const filterVal = ['Dt', 'TotalTrains', 'TotalWheels', 'MVISAlerts']
        const list = this.exelArr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:'train_consolidated_rep_from_'+this.startdateFormatted +"_to_"+this.enddateFormatted,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })

    },

    handleMVISDownload() {

      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Tagged Wagon ID', 'Tagged Bogie ID', 'Side ', 'Defect Image','Defect Description', 'Action Taken']
        const filterVal = ['tagged_wagon_id', 'tagged_bogie_id', 'side', 'defect_image', 'defect_desc', 'action_taken', ]
        const list = this.mvis_defects_excel
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data ,
          filename:'mvis_defects_of_'+this.consol_trainconsolidated1[0]['train_id'],
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })

    },

    handleWagonDownload() {
      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Tagged Wagon ID', 'Wagon Number', 'Wagon Type']
        const filterVal = ['tagged_wagon_id', 'wagon_id', 'wagon_type']
        const list = this.consol_left_wagon_info_excel;
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data ,
          filename:'wagon_information_of_'+this.consol_trainconsolidated1[0]['train_id'],
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },

    handleAllWheelDownload() {
      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Axle ID', 'Tagged Loco/Wagon ID', 'Axle Speed']
        const filterVal = ['axle_id', 'rake_id', 'axle_speed']
        const list = this.consol_traindetailed_excel
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data ,
          filename:'all_wheel_defects_of_'+this.consol_trainconsolidated1[0]['train_id'],
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },

    handleTrainWiseDownload() {

      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Tagged Train ID', 'DFIS ID', 'Direction', 'Entry Time', 'Train Speed', 'Total Axles', 'MVIS Alerts']
        const filterVal = ['TaggedTrainID', 'DFISID', 'Direction', 'EntryTime', 'TrainSpeed', 'TotalAxles', 'MVISAlerts']
        const list = this.exelArrTrainWise
        console.log(this.exelArrTrainWise);
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:'train_consolidated_rep_trainwise_from_'+this.startdateFormatted +"_to_"+this.enddateFormatted,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })

    },

     formatJson(filterVal, jsonData) {

      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    putTDcolor (direction) {
      let color = (direction === 'in' ) ? 'red' : 'green';
    	return color;
    },
    getTorpedoStatus (torpedo_status) {
      if (torpedo_status == 'loaded') return 'mdi-battery mdi-rotate-90'
      else if (torpedo_status == 'empty') return 'mdi-battery-outline mdi-rotate-90'
      else return 'mdi-block-helper'
    },
    putTScolor (torpedo_status) {
      let color = (torpedo_status === 'empty' ) ? 'green' : 'red';
    	return color;
    },

    getCurrentDateIST() {
        var dateUTC = (new Date());
        var dateUTC = dateUTC.getTime();
        var dateIST = new Date(dateUTC);
        //date shifting for IST timezone (+5 hours and 30 minutes)
        dateIST.setHours(dateIST.getHours() + 5);
        dateIST.setMinutes(dateIST.getMinutes() + 30);
        return (new Date(dateIST).toISOString().substr(0, 10));
      },

    convertTimestamp(timestamp) {
      if(timestamp != null) {
        var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
        sec = ('0' + d.getSeconds()).slice(-2),
        ampm = 'AM',
        time;

        if (hh > 12) {
          h = hh - 12;
          ampm = 'PM';
        } else if (hh === 12) {
          h = 12;
          ampm = 'PM';
        } else if (hh == 0) {
          h = 12;
        }

      // ie: 2013-02-18 8:35 AM
        time =  dd + '-' + mm + '-' + yyyy + ' ' + h + ':' + min + ':' + sec + ' ' + ampm
      }
      else {
        time = ' '
      }
      return time;
    },

      timeDifference(date1,date2) {
        if(date1 != null) {
          var d1 = new Date(0);
          var d2 = new Date(0);
          var d3 = new Date(0);
          d1.setUTCSeconds(date1);
          d2.setUTCSeconds(date2);

          var diffSec_temp, diffMin_temp, hr_temp;
          var diffHr = 0, diffMin, diffSec;

          diffSec_temp = (d1.getTime() - d2.getTime()) / 1000;

          if((diffSec_temp / 60) > 60) {
            diffMin_temp = parseInt(diffSec_temp / 60);
            hr_temp = 1;
            while((hr_temp * 60) < diffMin_temp) {
              hr_temp++;
            }
            diffHr = hr_temp - 1; //to get the prev hour value
            diffMin = diffMin_temp - (diffHr * 60); //to get the minute value
            diffSec = parseInt(((diffSec_temp / 60) % 1) * 60); //to get the seconds value
          }
          else {
          diffMin = parseInt(diffSec_temp / 60); //to get minutes (quotient only)
          diffSec = diffSec_temp - (diffMin * 60);

          }
          return diffHr + ' ' + 'hours' + ' ' + diffMin + ' ' + 'minutes' + ' ' + diffSec + ' ' + 'seconds';
        }
        else {
          return ' '
        }

    },

      formatDate(d)
      {
        var date = new Date(d)
        var dd = date.getDate();
        var mm = date.getMonth()+1;
        var yyyy = date.getFullYear();
        var hh = d.getHours();
        var min = ('0' + d.getMinutes()).slice(-2);		// Add leading 0.
        var sec = ('0' + d.getSeconds()).slice(-2);
        if(dd<10){dd='0'+dd}
        if(mm<10){mm='0'+mm};
        return d = yyyy+'-'+mm+'-'+dd+' '+hh+':'+min+':'+sec
      },

      submit() {
        this.disabled = true;  
        console.log(this.alarm_type, this.parseDate1(this.startdateFormatted), this.parseDate1(this.enddateFormatted), this.wagon_type,this.dir.value,this.def_typ.value);
      // console.log(this.formatDate(this.datetime), this.formatDate(this.datetime1));
      this.consol = [];
      this.exelArr = [];
      this.exelArrTrainWise = [];
      this.startDate = (this.startdateFormatted);
      this.endDate = (this.enddateFormatted);

      Api().post('/api/train_information', {
        start: this.startDate,
        end: this.endDate,
        alarmtype: this.alarm_type,
        train_type: this.wagon_type,
        dir: this.dir.value,
        defType: this.def_typ.value,
      })
    .then((response) => {
      // console.log(response.data);
      this.trainsEE = response.data;
      this.entry_exit_total_train = this.trainsEE.final_result;
      this.mvis_result_total_train = this.trainsEE.mvis_result;
      this.mvis_feedback = this.trainsEE.mvis_feedback;
      console.log('this.mvis_feedback', this.mvis_feedback);

      if (this.alarm_type.text === 'All') {
        for (let i in this.entry_exit_total_train.result) {
            this.consol.push({
              'date': this.entry_exit_total_train.result[i][0], //timestamp value
              'total_train_processed': this.mvis_result_total_train.mvis_result[i][2],
              // 'total_train_unprocessed': this.entry_exit_total_train.result[i][2],
              // 'train_alerts': this.entry_exit_total_train.result[i][3],
              'total_wheels': (this.entry_exit_total_train.total_axles),
	            'total_wagons': Math.round((this.entry_exit_total_train.total_axles)/4),
              'mvis_alerts': this.mvis_result_total_train.mvis_result[i][1],
              'feedback_available': this.mvis_feedback.mvis_feedback_count[i][1],
              'true_count': this.mvis_feedback.mvis_feedback_count[i][2],
              'false_count': this.mvis_feedback.mvis_feedback_count[i][3],
              // 'fwild_maintenance': this.entry_exit_total_train.result[i][5],
              // 'fwild_critical': this.entry_exit_total_train.result[i][6],
              'day_true_percentage': parseFloat((this.mvis_feedback.mvis_feedback_count[i][2] * 100) / this.mvis_result_total_train.mvis_result[i][1]).toFixed(2),
              'day_false_percentage': parseFloat((this.mvis_feedback.mvis_feedback_count[i][3] * 100) / this.mvis_result_total_train.mvis_result[i][1]).toFixed(2),
            })
        }
       }

      console.log('this.consol', this.consol);

      /*
	for(let i in this.entry_exit_total_train.result) {
          let Dt = this.entry_exit_total_train.result[i][0]
          let total_train_processed = this.entry_exit_total_train.result[i][1]
          let total_wheels = Math.round(this.entry_exit_total_train.result[i][4])
	  let total_wagons = Math.round((this.entry_exit_total_train.result[i][4] - (this.entry_exit_total_train.result[i][1]*6))/4)
          let mvisAlerts = this.mvis_result_total_train.mvis_result[i][1]

        let data = {
          'Dt': Dt,
          'TotalTrains': total_train_processed,
          'TotalWheels': total_wheels,
          'TotalWagons': total_wagons,
          'MVISAlerts': mvisAlerts,
        }
        this.exelArr.push(data)
        }
	*/
    })
    .catch(function (error) {
      //  console.log(error);
      ApiResponse.checkErrorCode(error.response.status);
    });
    },
  },

    computed: {
    itemsWithIndex() {
      // console.log(this.consol);
      return this.consol.map(
        (consol, index) => ({
          ...consol,
          index: index + 1
        }))
    },

    showDailyAlerts() {

      this.headersDailyArr = [...this.headers_daily];

      if (this.alarm_type.text === 'All') {
          for (let i = 0; i < 3; i++) {
            this.headersDailyArr.push(this.headers_alerts[i]);
          }
        return this.headersDailyArr;
       } else if (this.alarm_type.text === 'MVIS Alerts') {
        this.headersDailyArr = [...this.headers_mvis_alerts];
        return this.headersDailyArr;
       } else {
        if (this.headersDailyArr.length === 8) {
          this.headersDailyArr = [...this.headers_daily];
        }

        this.headersDailyArr.push(this.alarm_type);

        if (this.headersDailyArr.length > 6) {
          this.headersDailyArr[5] = this.headersDailyArr[6];
          this.headersDailyArr.pop();
        }
        return this.headersDailyArr;
      }


    },

    showTrainwiseAlerts() {

    this.headersTrainwiseArr = [...this.headers_train_wise];

    if (this.alarm_type.text === 'All') {
      for (let i = 0; i < 3; i++) {
        this.headersTrainwiseArr.push(this.headers_alerts[i]);
      }
      return this.headersTrainwiseArr;
    } else {

      if (this.headersTrainwiseArr.length === 9) {
        this.headersTrainwiseArr = [...this.headers_train_wise];
      }

      this.headersTrainwiseArr.push(this.alarm_type);

      if (this.headersTrainwiseArr.length > 7) {
        this.headersTrainwiseArr[6] = this.headersTrainwiseArr[7];
        this.headersTrainwiseArr.pop();
      }
      return this.headersTrainwiseArr;
    }
  },

  showWagonInfoHeader() {
    if (this.roleName != 'General') {
      this.header_left_wagon_info.push({ text: 'Edit Wagon Number' ,value:'edit', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" });
      return this.header_left_wagon_info;
    }
    return this.header_left_wagon_info;
  },
  },
}

</script>

<style lang="scss">
.v-sheet {
  border-radius: 4px;
}
</style> 
